<template>
  <div>
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="handleDelete('delete this product')">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div v-if="model && model.allowed_location">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <form class="row pad-to-15">
        <div class="col-md-12 " v-if="errors.has('error')">
          <div class="alert alert-danger">{{getError('error')}}
          </div>
        </div>
        <div class="col-md-12 " v-if="errors.items.length">
          <div class="alert alert-danger alert-custom-danger">{{$t('catalogProd.errorOptions')}}</div>
        </div>
        <div class="col-md-12 " v-if="nullProductOptionValues">
          <div class="alert alert-danger alert-custom-danger">{{$t('catalogProd.productOptionError')}}</div>
        </div>
        <div class="col-md-12 " v-if="hasProductOptionsWithoutCompanyOptions">
          <div class="alert alert-danger alert-custom-danger">{{$t('catalogProd.couldNotFetchProductOptions')}}</div>
        </div>

        <div id="outer-container" class="company-details">
          <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
            <div class="card-content">
              <div class="clearfix row pad-lf-10 pad-rg-10 space-between" style="padding: 0px 20px;">
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'description', errorT: invalidTabs.includes('description') }]"
                  @click.prevent="openSection('description')"
                >{{$t('catalogProd.prod_desc')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'general', errorT: invalidTabs.includes('general') }]"
                  @click.prevent="openSection('general')"
                >{{$t('catalogProd.prod_general')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'price', errorT: invalidTabs.includes('price') }]"
                  @click.prevent="openSection('price')"
                >{{$t('catalogProd.prod_price')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'location', errorT: invalidTabs.includes('location') }]"
                  @click.prevent="openSection('location')"
                >{{$t('catalogProd.prod_loc')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'options', errorT: invalidTabs.includes('options') }]"
                  @click.prevent="openSection('options')"
                >{{$t('catalogProd.prod_opt')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'marketing', errorT: invalidTabs.includes('marketing') }]"
                  @click.prevent="openSection('marketing')"
                >{{$t('catalogProd.prod_mark')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'label', errorT: invalidTabs.includes('label') }]"
                  @click.prevent="openSection('label')"
                >{{$t('catalogProd.prod_lab')}}</a>
                <a
                  class="btn btn-fill btn-primary"
                  :class="[{ active: currentSection === 'settings', errorT: invalidTabs.includes('settings') }]"
                  @click.prevent="openSection('settings')"
                >{{$t('catalogProd.prod_set')}}</a>
              </div>
            </div>
          </div>


          <div v-show="currentSection === 'description'" id="description">



            <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
              <div class="card-content">
                <div class="clearfix row pad-lf-10 pad-rg-10 space-between" style="padding: 0px 20px;">
                  <a
                    class="btn btn-fill btn-primary"
                    :class="[{ active: currentSubSection === 'l1', errorT: invalidTabs.includes('l1') }]"
                    @click.prevent="openSubSection('l1')"
                  >{{language}}</a>
                  <template v-for="lang in languages">
                    <a
                      class="btn btn-fill btn-primary"
                      :class="[{ active: currentSubSection === lang.id + '-' +lang.short, errorT: invalidTabs.includes(lang.id + '-' +lang.short) }]"
                      @click.prevent="openSubSection(lang.id + '-' +lang.short)"
                    >{{lang.short}}</a>
                  </template>
                </div>
              </div>
            </div>

            <div v-show="currentSubSection === 'l1'" id="l1" class="card-container">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-content">
                    <div class="form-group">
                      <label>{{$t('catalogProd.name')}}</label>
                      <input type="text"
                            name="name"
                            :placeholder="$t('catalogProd.name')"
                            v-validate="modelValidations.name"
                            data-vv-scope="description"
                            v-model="model.name"
                            class="form-control">
                      <small class="text-danger" v-if="errors.has('name')">
                        {{ getError('name') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <label>{{$t('catalogProd.desc')}}</label>
                      <textarea class="form-control" name="description" v-model="model.description" rows="8"></textarea>
                      <small class="text-danger" v-show="description.invalid">
                        {{ getError('description') }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template v-for="lang in model.localized_fields">
              <div class="card-container" v-show="currentSubSection === lang.language_id + '-' +lang.language_short " :id="lang.language_id + '-' +lang.language_short">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-content">
                      <div class="form-group">
                        <label>{{$t('catalogProd.name')}}</label>
                        <input type="text"
                              name="name"
                              :placeholder="$t('catalogProd.name')"
                              v-validate="modelValidations.name"
                              data-vv-scope="description"
                              v-model="lang.name"
                              class="form-control">
                        <small class="text-danger" v-if="errors.has('name')">
                          {{ getError('name') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <label>{{$t('catalogProd.desc')}}</label>
                        <textarea class="form-control" name="description" v-model="lang.description" rows="8"></textarea>
                        <small class="text-danger" v-show="description.invalid">
                          {{ getError('description') }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div class="card-container">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-content">
                    <div class="form-group">
                      <label class="pad-to-10">Info</label>
                      <div style="background: #fff">
                        <wysiwyg v-model="model.prod_info" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div v-show="currentSection === 'general'" id="general" class="card-container">
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="form-group">
                    <label>{{$t('catalogProd.image')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="2"
                      :file-list="model.imagelist"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="handleImgChnage"
                      :on-exceed="handleExceed"
                      :on-remove="handleRemove"
                      :auto-upload="false">
                      <img src="/static/img/icons/icon-plus-primary.png">
                      <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                    </el-upload>
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.image_size')}}</label>
                    <select name="image_size"
                                  class="form-control"
                                  data-vv-as="image_size"
                                  ref="image_size"
                                  v-model="model.image_size">
                      <option value="cover"
                              label="Cover"
                              key="cover">
                      </option>
                      <option value="contain"
                              label="Contain"
                              key="contain">
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.imageMore')}}</label>
                    <el-upload
                      action=""
                      ref="upload"
                      :limit="5"
                      multiple
                      :file-list="model.moreimagelist"
                      list-type="picture-card"
                      accept=" .jpg, .jpeg, .png"
                      :on-change="handleMoreImgChnage"
                      :on-exceed="handleExceed"
                      :on-remove="handleMoreRemove"
                      :auto-upload="false">
                      <img src="/static/img/icons/icon-plus-primary.png">
                      <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                    </el-upload>
                  </div>
                  <template v-if="!isNew()">
                    <div class="form-group">
                      <div class="row" v-if="model.video">
                        <div class="col-md-6">
                          <button class="btn btn-info btn-icon " @click.prevent="goToLink(model.video, '_blank')">{{$t('catalogProd.video')}}</button>
                        </div>
                        <div class="col-md-6">
                          <button class="btn btn-danger btn-icon" :title="$t('general.delete')" @click.prevent="removeVideo(model.id)">Remove video</button>
                        </div>
                      </div>
                      <template v-else>
                        <label >{{$t('catalogProd.video')}}</label>
                        <input v-if="!model.video" type="file" ref="video" @change="handleVideoChange" />
                      </template>
                    </div>
                    <div class="form-group">
                      <label>{{$t('catalogProd.video_thumbnail')}}</label>
                      <el-upload
                        action=""
                        ref="upload_video_thumbnail"
                        :limit="2"
                        :file-list="model.video_thumbnail"
                        list-type="picture-card"
                        accept=" .jpg, .jpeg, .png"
                        :on-change="handleVideoThumbChnage"
                        :on-exceed="handleExceed"
                        :on-remove="handleVideoThumbRemove"
                        :auto-upload="false">
                        <img src="/static/img/icons/icon-plus-primary.png">
                        <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                      </el-upload>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="form-group">
                    <label>{{$t('catalogProd.status')}}</label>
                    <select name="active"
                            v-model="model.active"
                            class="form-control">
                      <option :value="true">{{$t('general.active')}}</option>
                      <option :value="false">{{$t('general.inactive')}}</option>
                    </select>
                    <small class="text-danger" v-if="errors.has('status')">
                      {{ getError('status') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.category')}}</label>
                    <select name="category_id"
                                  class="form-control"
                                  data-vv-as="category"
                                  ref="category_id"
                                  v-model="model.category_id"
                                  v-validate="modelValidations.category_id"
                                  data-vv-scope="general">
                      <!-- <option value="">None</option> -->
                      <option v-for="option in mainCategories"
                                :value="option.id"
                                :label="option.name"
                                :key="option.id">
                      </option>
                    </select>
                    <small class="text-danger" v-show="category_id.invalid">
                      {{ getError('category_id') }}
                    </small>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-12">{{$t('catalogProd.secondaryCategory')}}</label>
                    <div class="col-md-12">
                      <v-select v-model="model.secondary_categories"
                                  @change="filterSecondaryCategories"
                                  multiple
                                  :options="mainCategoriesForSecondaryCategories"
                                  label="name">
                      </v-select></div>
                                  <!-- :selectable="(option) => option.id == model.category_id" -->
                      <!-- <small class="text-danger" v-if="errors.has('category_id')">
                        {{ getError('category_id') }}
                      </small> -->
                  </div>
                  <template v-if="kdsSectionsParent.length">
                    <div class="form-group">
                      <label>{{$t('kds.section')}}</label>
                      <select
                        name="type"
                        class="form-control"
                        v-validate="modelValidations.kds_section_id || {}"
                        data-vv-scope="general"
                        v-model="model.kds_section_id"
                      >
                        <option :value="null" :label="$t('general.select')"> </option>
                        <option
                          v-for="section in kdsSectionsParent"
                          :value="section.id"
                          :label="section.name"
                          :key="section.id">
                        </option>
                      </select>
                      <small class="text-danger" v-if="errors.has('kds_section_id')">
                        {{ getError('kds_section_id') }}
                      </small>
                    </div>
                    <div class="form-group" :class="{'has-error': coursesTypeHasError}">
                      <label>{{$t('catalogProd.coursesType')}}</label>
                      <input type="number"
                              min="0"
                              :max="coursesTypeMax"
                              name="courses_type"
                              v-validate="modelValidations.courses_type"
                              data-vv-scope="general"
                              v-model.number="model.courses_type"
                              @input="validateCoursesType"
                              class="form-control">
                      <small class="text-danger" v-if="coursesTypeHasError">
                        {{ coursesTypeErrorMessage }}
                      </small>
                    </div>
                  </template>
                  <div class="form-group">
                    <label>{{$t('catalogProd.preparation_time_in_minutes')}}</label>
                    <input type="number"
                          min="0"
                          step="1"
                          name="preparation_time_in_minutes"
                          :placeholder="$t('catalogProd.preparation_time_in_minutes')"
                          v-model="preparationTimeInMinutes"
                          class="form-control">
                    <small class="text-muted" v-if="categoryPreparationTimeInMinutes !== null">
                      {{ $t('catalogProd.category_preparation_time_hint', { minutes: categoryPreparationTimeInMinutes }) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="currentSection === 'price'" id="price" data-vv-scope="price" class="card-container">
            <div class="col-md-12">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>{{$t('catalogProd.price')}} ({{currency}})</label>
                        <input type="number"
                                min="0"
                              name="price"
                              :placeholder="$t('catalogProd.price')"
                              v-validate="modelValidations.price"
                              data-vv-scope="price"
                              v-model="model.price"
                              @change="handlePriceChange"
                              class="form-control">
                        <small class="text-danger" v-show="price.invalid">
                          {{ getError('price') }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <!-- v-validate="modelValidations.measurements_units_id" -->
                        <label class="control-label">{{$t('settingCompany.measurements_units_id')}}</label>
                        <select v-model="model.measurements_units_id"
                                name="measurements_units_id"
                                class="select-primary form-control"
                                ref="measurements_units_id"
                                data-vv-scope="price"
                          >
                            <option v-for="mu in measurementsUnits"
                                  class="select-primary"
                                  :value="mu.id">{{mu.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>{{$t('settingCompany.quantitative_unit')}}</label>
                        <input type="number"
                                min="0"
                              name="quantitative_unit"
                              :placeholder="$t('settingCompany.quantitative_unit')"
                              v-validate="modelValidations.quantitative_unit"
                              data-vv-scope="price"
                              v-model="model.quantitative_unit"
                              @change="handlePriceChange"
                              class="form-control">
                        <!-- <small class="text-danger" v-show="quantitative_unit.invalid">
                          {{ getError('price') }}
                        </small> -->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>{{$t('catalogProd.minQuantity')}}</label>
                        <input type="number"
                                min="0"
                                name="min_quantity"
                                placeholder="3"
                                v-model="model.min_quantity"
                                class="form-control">
                                <small class="help-block"> {{$t('general.contactSuportFeature')}} </small>
                      </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- DISABLED -->
            <div class="col-md-12" v-if="0">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <template v-for="pf in pricesFor">
                      <div class="col-md-12" :style="( (pf.id != 1 && pf.id <= 3) || (model.price_list && model.price_list[pf.id].price)) ? '' : '' ">
                        <!-- else display: none; -->
                        <div class="form-group" v-if="model.price_list && model.price_list[pf.id]">
                          <label>{{$t('pricesFor.' + pf.id)}} ({{currency}})</label>
                          <input type="number"
                                  min="0"
                                name="price"
                                :placeholder="$t('catalogProd.price')"
                                v-model="model.price_list[pf.id].price"
                                class="form-control">
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{ $t('catalogProd.usePriceToShow') }}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.use_price_to_show" type="success"></p-switch>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group" v-if="model.use_price_to_show">
                        <label>{{$t('catalogProd.priceToShow')}} ({{currency}})</label>
                        <input type="number"
                                min="0"
                              name="price"
                              :placeholder="$t('catalogProd.price')"
                              v-validate="modelValidations.price_to_show"
                              data-vv-scope="price"
                              v-model="model.price_to_show"
                              class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="form-group">
                    <label>{{ $t('catalogProd.useDiscountPrice') }}</label>
                    <div class="pad-to-10">
                      <p-switch v-model="model.is_discounted" @input="handleDiscountedPrice($event)" type="success"></p-switch>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{$t('marketingCampaigns.validFromTo')}}</label>
                    <br/>
                    <el-date-picker type="daterange"
                                    v-model="model.discountPeriod"
                                    @change="handleDateChange($event)"
                                    :disabled="!model.is_discounted"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <small class="text-danger" v-if="errors.has('date_from')">
                      {{ getError('date_from') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.newPrice')}}({{currency}})</label>
                    <input type="number"
                          min="0"
                          name="new_price"
                          :placeholder="$t('catalogProd.newPrice')"
                          v-model="model.new_price"
                          :disabled="!model.is_discounted"
                          @change="handleNewPriceChange"
                          v-validate="model.is_discounted ? {required: true,  min_value: 0, max_value: model.old_price - 0.1} : ''"
                          data-vv-scope="price"
                          class="form-control">
                    <small class="text-danger" v-if="errors.has('new_price')">
                      {{ getError('new_price') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>{{ $t('catalogProd.oldPrice') }}({{currency}})</label>
                    <input type="number"
                          min="0"
                          name="old_price"
                          :placeholder="$t('catalogProd.oldPrice')"
                          v-model="model.old_price"
                          disabled
                          v-validate="model.is_discounted ? modelValidations.old_price : ''"
                          data-vv-scope="price"
                          class="form-control">
                    <small class="text-danger" v-if="errors.has('old_price')">
                      {{ getError('old_price') }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="currentSection === 'location'" id="location" class="card-container">
            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-content">
                    <template v-if="userRole !== 'LOCATION_ADMIN' || userRole !== 'LOCATION_STORE_ADMIN'">
                      <div class="row" >
                        <div class="col-md-12">
                          <div class="" direction="horizontal" type="tabs">
                            <h6>{{$t('catalogProd.locationSettings')}}</h6>
                            <hr class="sm">
                          </div>
                        </div>
                        <div class="col-md-12" v-if="showLocations">
                          <div class="form-group row">
                            <label class="col-md-12">{{$t('catalogProd.availableIn')}}</label>
                            <div class="col-md-12" >
                              <v-select v-model="model.location_ids"
                                          @input="checkLocations(model)"
                                          multiple
                                          :options="locations"
                                          label="name"
                                          :placeholder="$t('general.all')">
                              </v-select></div>
                              <small class="text-danger" v-if="errors.has('location_ids')">
                                {{ getError('location_ids') }}
                              </small>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group product-override-group">
                            <label><span>{{$t('catalogProd.deliveryMethodsandHours')}}</span></label>
                            <div @click="updateDeliverySettings()">
                              <p-checkbox
                                @input="handleChangeOverrideDelivery()"
                                :value="true"
                                v-model="model.override_delivery"
                              >{{$t('catalogProd.overrideSettings')}}</p-checkbox>
                              <small class="text-danger" v-if="model.override_delivery && (errors.has('isCheckedDay') || errors.has('isCheckedDeliveryMethod'))">
                                {{ $t('validations.chooseLocationAndDeliveryMethod') }}
                              </small>
                              <small class="text-danger" v-if="model.override_delivery && errors.has('intervalError')">
                                {{ $t('validations.timeInterval') }}
                              </small>
                              <div v-if="overrideDeliveryErrors.length">
                                <small class="text-danger d-block" v-for="(err, idx) in overrideDeliveryErrors" :key="idx">{{ err }}</small>
                              </div>
                            </div>

                            <el-collapse
                              v-if="model.override_delivery"
                              accordion
                              class="product-override-collapse"
                            >
                              <el-collapse-item
                                v-for="(loc, locId) in model.override_settings"
                                v-show="showThisLocation(loc.loc_id)"
                                :key="'override-' + loc.loc_id + '-' + locId"
                                :title="overrideLocationTitle(loc.loc_id)"
                                :name="String(loc.loc_id)"
                              >
                                <hr class="sm">
                                <template v-for="(orderInterval, orderIntervalId) in loc.delivery">
                                  <div class="col-md-12" :key="'dm-' + locId + '-' + orderIntervalId">
                                    <h4>
                                      {{ $t('settingCompany.' + deliveryMethodLabel(orderInterval, orderIntervalId)) }}
                                      <button
                                        class="btn btn-success btn-sm"
                                        @click.prevent="addNewOverrideInterval(locId, orderIntervalId, deliveryMethodLabel(orderInterval, orderIntervalId))"
                                      >+</button>
                                    </h4>

                                    <template v-for="(order, orderId) in orderInterval">
                                      <div class="col-md-12" :key="'interval-' + locId + '-' + orderIntervalId + '-' + orderId">
                                        <p-checkbox
                                          @input="handleChangeIsCheckedDeliveryMethod(locId, orderIntervalId, orderId)"
                                          v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                                          :value="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                                        >
                                          {{ $t('general.active') }}
                                        </p-checkbox>

                                        {{ $t('general.from') }}
                                        <el-time-select
                                          :disabled="!model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                                          placeholder="Select time"
                                          v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_from']"
                                          class="in-inline-160"
                                          :picker-options="pickerOptions"
                                        />

                                        {{ $t('general.to') }}
                                        <el-time-select
                                          :disabled="!model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                                          placeholder="Select time"
                                          v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['available_to']"
                                          class="in-inline-160"
                                          :picker-options="pickerOptions"
                                        />

                                        <button
                                          class="btn btn-danger btn-sm"
                                          @click.prevent="removeOverrideInterval(locId, orderIntervalId, orderId)"
                                        >-</button>
                                      </div>

                                      <div class="col-md-12 pull-left-first-child" style="flex-wrap:wrap;" :key="'days-' + locId + '-' + orderIntervalId + '-' + orderId">
                                        <template v-for="(d, key) in weekDays()">
                                          <p-checkbox
                                            :key="'day-' + locId + '-' + orderIntervalId + '-' + orderId + '-' + key"
                                            @input="handleCheckDay(locId, orderIntervalId, orderId)"
                                            :disabled="!model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active']"
                                            class="inline-auto mar-rt-5"
                                            v-model="model.override_settings[locId]['delivery'][orderIntervalId][orderId][d.toLowerCase()]"
                                            :value="d"
                                          >
                                            {{ $t('catalogProd.' + d) }}
                                          </p-checkbox>
                                        </template>
                                      </div>

                                      <div class="col-md-12 pull-left-first-child" style="flex-wrap:wrap;" :key="'day-err-' + locId + '-' + orderIntervalId + '-' + orderId">
                                        <small
                                          class="text-danger"
                                          v-if="model.override_settings[locId]['delivery'][orderIntervalId][orderId]['active'] &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].monday &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].tuesday &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].wednesday &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].thursday &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].friday &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].saturday &&
                                                !model.override_settings[locId]['delivery'][orderIntervalId][orderId].sunday"
                                        >
                                          {{ $t('validations.chooseDay') }}
                                        </small>
                                      </div>
                                    </template>
                                  </div>
                                </template>
                              </el-collapse-item>
                            </el-collapse>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-if="has_charisma_location" class="card mar-to-15">
                  <div class="card-content">
                    <div class="row">
                      <div class="col-md-12">
                        <h6>{{ $t('charisma.charismaInventory') }}</h6>
                        <hr class="sm">
                      </div>
                    </div>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>{{ $t('general.administration') }}</th>
                          <th>{{ $t('marketingCampaigns.locations') }}</th>
                          <th>{{ $t('general.actions') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!administrations || !administrations.length">
                          <td colspan="3" class="text-center text-muted">
                            {{ $t('general.noAdministrationsAvailable') }}
                          </td>
                        </tr>
                        <tr v-if="administrations && administrations.length && (!model.administrations || !model.administrations.length)">
                          <td colspan="3" class="text-center text-muted">
                            {{ $t('general.setAdministration') }}
                          </td>
                        </tr>
                        <tr v-for="(row, index) in model.administrations" :key="index">
                          <td>
                            <select
                              v-model="row.administration_id"
                              class="form-control"
                              :placeholder="$t('general.select')"
                            >
                              <option :value="null" disabled>{{ $t('general.select') }}</option>
                              <option
                                v-for="admin in availableAdministrations(row.administration_id)"
                                :value="admin.id"
                                :key="admin.id"
                              >
                                {{ admin.name }}
                              </option>
                            </select>
                            <small v-if="errors.has(`administration_id_${index}`)" class="text-danger">
                              {{ getError(`administration_id_${index}`) }}
                            </small>
                          </td>
                          <td>
                            <el-select
                              v-model="row.location_ids"
                              multiple
                              collapse-tags
                              clearable
                              filterable
                              class="charisma-location-select"
                              :placeholder="$t('settingsOrdering.selectLocations')">
                              <el-option
                                v-for="loc in charismaLocations"
                                :key="loc.id"
                                :label="loc.name"
                                :value="loc.id">
                              </el-option>
                            </el-select>
                          </td>
                          <td>
                            <button class="btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5"
                              @click.prevent="removeAdministrationRow(index)">
                              <i class="ti-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <button v-if="administrations && administrations.length && (!model.administrations || (model.administrations && model.administrations.length < administrations.length))" class="btn btn-primary" @click.prevent="addAdministrationRow">
                      <img src="/static/img/icons/add.png" />
                      {{ $t('general.add') }}
                    </button>
                  </div>
                </div>
                <div class="card mar-to-15">
                  <div class="card-content">
                    <el-collapse accordion>
                      <el-collapse-item :title= "$t('catalogProd.availabilityTitle')" class="product-availability">
                        <div class="form-group">
                          <label>{{$t('catalogProd.productNotAvailable')}}</label>
                          <br/>
                          <p-switch v-model="model.is_not_available" type="success" @input="handleProductUnavailable"></p-switch>
                        </div>
                        {{$t('catalogProd.fromTime')}}
                        <el-time-select :placeholder="$t('catalogProd.timePlaceholder')"
                                        v-model="model.is_not_available_from"
                                        :picker-options="pickerOptions"
                                        class="in-inline-165"
                                        >
                        </el-time-select>
                        {{$t('catalogProd.toTime')}}
                        <el-time-select :placeholder="$t('catalogProd.timePlaceholder')"
                                        v-model="model.is_not_available_to"
                                        :picker-options="pickerOptions"
                                        class="in-inline-165"
                                        >
                        </el-time-select>
                        <br>
                        <small class="text-danger" v-if="errorProductUnavailable">
                          {{ errorProductUnavailable }}
                        </small>
                        <br>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <template v-if="use_gestiune">
                  <div class="card">
                    <div class="card-content">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="" direction="horizontal" type="tabs">
                            <h6>{{$t('gestiune.productManagement')}}</h6>
                            <hr class="sm">
                          </div>
                        </div>
                      </div>
                      <div class="vat-boxes">
                        <div
                          v-for="(entries, vat) in model.pos_id_gruped_by_vat"
                          :key="vat"
                          v-if="vat != 'NO_VAT'"
                          class="vat-box"
                        >
                          <div class="vat-header">
                            <strong>VAT: {{ vat }}</strong>
                          </div>

                          <div class="vat-body">
                            <div v-if="loadingVat === vat" class="mini-loader">
                              {{$t('gestiune.prodLoading')}}
                            </div>

                            <div v-else>
                              <div v-if="linkedProducts[vat]">
                                <div class="linked-product-id">
                                  Id: {{linkedProducts[vat]._id}}
                                </div>
                                <div class="linked-product-name">
                                  {{ linkedProducts[vat].name }} - <div style="display: inline;" v-html="showGestiuneCategory(linkedProducts[vat].categorie)"></div>
                                  <span v-if="linkedProducts && linkedProducts[vat] && linkedProducts[vat].reteta && linkedProducts[vat].reteta.items && linkedProducts[vat].reteta.items.length" class="reteta">
                                    Reteta
                                  </span>
                                </div>
                                <div class="linked-product-extra">

                                </div>
                              </div>

                              <div v-else class="no-link">
                                {{$t('gestiune.noGestion')}}
                              </div>

                              <!-- <template v-if="isNew() && !linkedProducts[vat]">
                                <p-checkbox
                                      v-model="use_auto[vat]"
                                    >{{$t('gestiune.autoActive')}}</p-checkbox>
                              </template> -->

                                <!-- v-if="!use_auto[vat]" -->
                              <button
                                class="btn btn-sm change mar-to-10"
                                @click.prevent="openChangeModal(vat)"
                              >
                              <template v-if="linkedProducts[vat]">
                                {{$t('gestiune.change')}}
                              </template>
                              <template v-else>
                                {{$t('general.add')}}
                              </template>
                              </button>
                              <!-- <button
                                v-if="linkedProducts[vat]"
                                class="btn btn-sm mar-to-10"
                                @click.prevent="removeGestionLink(vat)"
                              >
                              {{$t('gestiune.removeLink')}}
                              </button> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

              </div>
            </div>
          </div>

          <div v-show="currentSection === 'options'" id="options" class="card-container">
            <div class="col-md-12">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group row">
                          <label class="col-md-12">{{$t('catalogProd.groupOption')}}</label>
                          <div class="col-md-12" >
                            <v-select v-model="model.group_options"
                                        @input="changeGroupOptions()"
                                        multiple
                                        :options="groupOptions"

                                        label="name"
                                        :placeholder="$t('general.all')">
                            </v-select></div>
                            <small class="text-danger" v-if="errors.has('group_options')">
                              {{ getError('group_options') }}
                            </small>
                        </div>

                      <div class="prod-tabs" v-if="!model.group_options || (model.group_options && !model.group_options.length)" direction="horizontal" type="tabs">
                        <div class="col-md-12 display-flex align-items-center justify-content-space-between no-padding">
                          <h6>{{$t('catalogProdOpt.plural')}}</h6>
                          <button class="btn btn-plus btn-icon no-padding"
                                  v-if="this.model.product_options && Object.keys(productOptionsFiltered).length > model.product_options.length"
                                  @click.prevent="addNewOption()"
                                  :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                              <img src="/static/img/icons/icon-plus-primary.png">
                          </button>
                        </div>
                        <div class="col-md-12 pad-lf-0 pad-rg-0">
                          <hr class="sm">
                        </div>
                        <div :title="$t('catalogProdOpt.plural')" class="text-left">
                          <div class="row">
                            <div class="col-md-12 pad-to-10 " >
                              <!-- <p v-if="model.product_options.length == 0" class="">No options added yet.</p> -->
                              <el-collapse ref="elColl" v-model="tabIndex" accordion>
                                <template v-for="(option, idxO) in model.product_options">
                                  <button class="btn btn-danger pull-left btn-icon btn-icon-delete mar-15" :title="$t('general.delete')" @click.prevent="deleteOption(idxO)"><i class="ti-close"></i></button>
                                    <!--   <input type="text"
                                          v-model="option.name"
                                          @input="updateName(idxO, option.id, option.name)"
                                          class="option-name form-control"
                                          :placeholder="$t('catalogProdOpt.single')"
                                          :disabled="!option.id"> -->
                                  <!-- <div class="pull-right disable-chck" @click="updateTabs(bussLocation.id + order.type, order.enabled)">
                                    <p-checkbox
                                      v-model="option.active"
                                      :label="'Active'"
                                    >{{$t('settingLocationGroups.active')}}</p-checkbox>
                                  </div> -->
                                  <el-collapse-item :title="getOptData(option, 'name')" :name="idxO">
                                    <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>{{$t('catalogProdOpt.single')}}</label>
                                          <select class="form-control"
                                                  v-model="model.product_options[idxO].company_option_id"
                                                  @change="changeOption(idxO, model.product_options[idxO].company_option_id)"
                                                  placeholder="Pick an option"
                                                  v-validate="{required: true}"
                                                  data-vv-scope="options"
                                                  >
                                            <option disabled value="null">{{$t('catalogProd.pickAnOption')}}</option>
                                            <template v-for="prOption in productOptionsFiltered">
                                              <option :value="prOption.id"
                                                      :disabled="disableOption(idxO, prOption.id, true) && model.product_options[idxO].company_option_id != prOption.id"
                                              >{{ prOption.name }} {{ prOption.label.length ? '(' + prOption.label + ')' : ''}} </option>
                                            </template>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>{{$t('general.required')}}</label>
                                          <select class="form-control" v-model="option.required">
                                            <option :value="true">{{$t('general.yes')}}</option>
                                            <option :value="false">{{$t('general.no')}}</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6" v-if="option.type == 'checkbox' || option.type == 'upload'">
                                        <div class="form-group">
                                          <label>{{$t('catalogProd.minNoSelected')}}</label>
                                          <input type="number" @change="validateOption(option, model.product_options[idxO].company_option_id)" class="form-control" name="min" v-model="option.min_no" />
                                          <small class="text-danger" v-if="errors.has('min' + model.product_options[idxO].company_option_id)">
                                            {{ getError('min' + model.product_options[idxO].company_option_id) }}
                                          </small>
                                          <small class="text-danger" v-if="errors.has('min_negative' + model.product_options[idxO].company_option_id)">
                                            {{ getError('min_negative' + model.product_options[idxO].company_option_id) }}
                                          </small>
                                        </div>
                                      </div>
                                      <div class="col-md-6" v-if="option.type == 'checkbox' || option.type == 'upload'">
                                        <div class="form-group">
                                          <label>{{$t('catalogProd.maxNoSelected')}}</label>
                                          <input type="number" @change="validateOption(option, model.product_options[idxO].company_option_id)" class="form-control" name="max" v-model="option.max_no" />
                                          <small class="text-danger" v-if="errors.has('max' + model.product_options[idxO].company_option_id)">
                                            {{ getError('max' + model.product_options[idxO].company_option_id) }}
                                          </small>
                                          <small class="text-danger" v-if="errors.has('max_negative' + model.product_options[idxO].company_option_id)">
                                            {{ getError('max_negative' + model.product_options[idxO].company_option_id) }}
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>{{$t('productOptions.hidePrices')}}</label>
                                          <select class="form-control" v-model="option.hide_prices">
                                            <option :value="true">{{$t('general.yes')}}</option>
                                            <option :value="false">{{$t('general.no')}}</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>{{$t('productOptions.hasDefaultValue')}}</label>
                                          <select class="form-control" v-model="option.has_default_value">
                                            <option :value="true">{{$t('general.yes')}}</option>
                                            <option :value="false">{{$t('general.no')}}</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <table class="table no-margin" v-if="option.id != ''">
                                      <thead>
                                        <tr>
                                          <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                          <th>{{$t('catalogProd.price')}} ({{currency}})
                                            <!-- <small class="xs">{{$t('catalogProd.leaveEmpty')}}</small> -->
                                          </th>
                                          <!-- <th>{{$t('catalogCateg.vat')}} <small>({{$t('catalogCateg.included')}})</small></th> -->
                                          <th>Pos Id 1</th>
                                          <th v-if="use_pos_id_per_product_option">Pos Id 2</th>
                                          <th v-if="use_quantity_per_product_option">Qty.</th>
                                          <!-- <th>{{$t('settingLocationGroups.active')}}</th> -->
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(value, idx) in option.values">
                                          <!-- {{ value }} -->
                                          <!-- <input type="hidden" v-model="option.id"> -->
                                          <td>
                                            <template v-if="productOptionsFiltered[getObjectByElemKeyValue('id', option.company_option_id, productOptionsFiltered)]">
                                              <el-select class="product-option-value-select"
                                                         v-model="value.company_option_value_id"
                                                         filterable
                                                         :filter-method="filterOptionValues"
                                                         @visible-change="resetOptionValueQuery"
                                                         :placeholder="$t('catalogProd.pickAnOption')"
                                                         @change="selectOptionValue($event, idxO, idx)"
                                                         v-validate="{required: true}"
                                                         data-vv-scope="options">
                                                <el-option v-for="prOption in productOptionsFiltered[getObjectByElemKeyValue('id', option.company_option_id, productOptionsFiltered)]['values']"
                                                           v-if="matchesOptionValueQuery(prOption.name, value.company_option_value_id, prOption.id)"
                                                           :key="prOption.id"
                                                           :label="prOption.name"
                                                           :value="prOption.id"
                                                           :disabled="disableOption(idxO, prOption.id, false) && value.company_option_value_id != prOption.id">
                                                </el-option>
                                              </el-select>
                                            </template>
                                          </td>
                                          <td>
                                            <div class="row">
                                              <div class="col-md-12">
                                                <input type="number"
                                                        v-validate="{min_value: 0}"
                                                        data-vv-scope="options"
                                                        class="form-control"
                                                        v-model="value.price">
                                              </div>
                                            </div>
                                          </td>
                                          <!-- <td>
                                            <div class="row">
                                              <div class="col-md-12">
                                                <select
                                                  v-model="value.vat_id"
                                                  class="form-control">
                                                  <option value="null">{{ $t('vat.selectVat') }}</option>
                                                  <option
                                                    v-for="vat in vatOptions"
                                                    :value="vat.id"
                                                  >{{ vat.amount }}
                                                  </option>
                                                </select>
                                              </div>
                                            </div>
                                          </td> -->
                                          <td>
                                            <div class="row">
                                              <div class="col-md-12">
                                                <input type="text"
                                                        class="form-control"
                                                        v-model="value.pos_id">
                                              </div>
                                            </div>
                                          </td>
                                          <td v-if="use_pos_id_per_product_option || (value.hasOwnProperty('pos_id_per_product') && value.pos_id_per_product)">
                                            <div class="row">
                                              <div class="col-md-12">
                                                <input type="text"
                                                        class="form-control"
                                                        v-model="value.pos_id_per_product">
                                              </div>
                                            </div>
                                          </td>
                                          <td v-if="use_quantity_per_product_option || (value.hasOwnProperty('quantity_per_option') && value.quantity_per_option) ">
                                            <div class="row">
                                              <div class="col-md-12">
                                                <input type="text"
                                                        class="form-control"
                                                        v-model="value.quantity_per_option">
                                              </div>
                                            </div>
                                          </td>
                                          <!-- <td>
                                            <div class="disable-chck option-active-check">
                                              <p-checkbox
                                                :disabled="value.active && isLastActiveOptionValue(option.values)"
                                                v-model="value.active"
                                              ></p-checkbox>
                                            </div>
                                          </td> -->

                                          <td><button class="btn btn-simple btn-icon " @click.prevent="deleteOptionValue(idxO, idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                        </tr>

                                      </tbody>
                                      <!-- <tfoot></tfoot> -->
                                    </table>
                                    <div class="pull-right" v-if="showAddButton(idxO, option)">
                                      <button title="" @click="validateOption(option, model.product_options[idxO].company_option_id)" class="btn btn-simple btn-icon mar-bt-5" @click.prevent="addNewOptionValue(idxO)"><i class="ti-plus"></i>
                                          {{$t('general.add')}} {{$t('catalogProdOpt.single')}} {{$t('catalogProdOpt.value')}}
                                      </button>
                                    </div>
                                  </el-collapse-item>
                                </template>
                              </el-collapse>
                            </div>
                            <div class="col-md-12 pad-to-15 pad-bt-10">

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-12">

                      <div class="prod-tabs" direction="horizontal" type="tabs">
                        <div class="col-md-12 display-flex align-items-center justify-content-space-between no-padding">
                          <h6>{{$t('filter.filters')}}</h6>
                          <button class="btn btn-icon btn-plus no-padding"
                                  v-if="this.model.product_filters && Object.keys(productAvailableFilters).length > this.model.product_filters.length"
                                  @click.prevent="addNewFilter()"
                                  :title="$t('general.add')  + ' ' + $t('filter.filter')" >
                            <img src="/static/img/icons/icon-plus-primary.png">
                          </button>
                        </div>
                        <div class="col-md-12 pad-lf-0 pad-rg-0">
                          <hr class="sm">
                        </div>
                        <div :title="$t('catalogProdOpt.plural')" class="text-left">
                          <div class="row">

                            <div class="col-md-12 pad-to-10 " >
                              <el-collapse ref="elColl" v-model="tabFilterIndex" accordion>
                                <template v-for="(filter, idxF) in model.product_filters">
                                  <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteFilter(idxF)"><i class="ti-close"></i></button>
                                <!--   <input type="text"
                                          v-model="option.name"
                                          @input="updateName(idxF, option.id, option.name)"
                                          class="option-name form-control"
                                          :placeholder="$t('catalogProdOpt.single')"
                                          :disabled="!option.id"> -->
                                  <el-collapse-item :title="getFilData(filter.filter_id, 'type')" :name="idxF">
                                    <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>{{$t('filter.filterType')}}</label>
                                          <select class="form-control"
                                                  v-model="filter.filter_id"
                                                  placeholder="Pick an filter"
                                                  :name="'filter'+filter.filter_id"
                                                  >
                                            <option disabled>{{$t('catalogProd.pickAnOption')}}</option>
                                            <template v-for="prFilter in productAvailableFilters">
                                              <option :value="prFilter.id"
                                                      :disabled="disableFilter(idxF, prFilter.id, true) && filter.filter_id != prFilter.id"
                                                      :label="prFilter.type"
                                                      :key="prFilter.id"
                                                      ></option>
                                            </template>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <table class="table no-margin" v-if="filter.id != ''">
                                      <thead>
                                        <tr>
                                          <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <template v-for="(paf, idxpaf) in productAvailableFilters">
                                          <template v-if="filter.filter_id == paf.id">

                                              <template v-for="(filVal, idnx) in filter.filter_value">
                                                <tr>
                                                  <input type="hidden" v-model="filter.id">
                                                  <td>

                                                    <div class="form-group">
                                                      <label> {{$t('catalogProdOpt.value')}} {{$t('filter.filter')}}</label>
                                                      <select class="form-control"
                                                              v-model="filVal.id"
                                                              placeholder="Pick an value"
                                                              v-validate="{required: true}"
                                                              data-vv-scope="options"
                                                              >
                                                        <option selected disabled>{{$t('catalogProd.pickAnOption')}}</option>
                                                        <template v-for="prFilterValue in paf.filter_value">
                                                          <option :value="prFilterValue.id"
                                                                  :disabled="disableFilterValue(idxF, prFilterValue.id, false)"
                                                                  v-validate="{required: true}"
                                                                  data-vv-scope="options"
                                                          >{{ prFilterValue.value }}</option>
                                                        </template>
                                                      </select>
                                                    </div>

                                                  </td>
                                                  <td><button class="btn btn-simple btn-icon " @click.prevent="deleteFilterValue(idxF, idnx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                                </tr>
                                              </template>

                                          </template>
                                        </template>

                                      </tbody>
                                    </table>

                                    <div class="pull-right" v-if="showAddButtonFilter(idxF, filter)">
                                      <button title="" class="btn btn-simple btn-icon mar-bt-5" @click.prevent="addNeFilterValue(idxF)"><i class="ti-plus"></i>
                                          {{$t('general.add')}} {{$t('catalogProdOpt.value')}} {{$t('filter.filter')}}
                                      </button>
                                    </div>


                                  </el-collapse-item>
                                </template>
                              </el-collapse>
                            </div>
                            <div class="col-md-12 pad-to-15 pad-bt-10">

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="prod-tabs" direction="horizontal" type="tabs">
                        <div class="col-md-12 display-flex align-items-center justify-content-space-between no-padding">
                          <h6>{{$t('catalogProd.aditionalInfo')}}</h6>
                          <button class="btn btn-plus no-padding"
                                  @click.prevent="addNewOtherInfo()"
                                  :title="$t('general.add')  + ' OtherInfo'" >
                              <img src="/static/img/icons/icon-plus-primary.png">
                          </button>
                        </div>
                        <div class="col-md-12 pad-lf-0 pad-rg-0">
                          <hr class="sm">
                        </div>
                        <div title="title" class="text-left">
                          <div class="row">

                            <div class="col-md-12 pad-to-10 " >
                              <el-collapse ref="elColl" v-model="tabOtherInfoIndex" accordion>
                                <template v-for="(info, id_info) in model.other_info">
                                  <template v-if="info.del != 1">
                                    <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteOtherInfo(id_info)"><i class="ti-close"></i></button>
                                    <el-collapse-item :title="info.title === '' ? 'Name' : info.title" :name="idxF">
                                      <div class="form-group">
                                        <label>{{$t('catalogProd.name')}}</label>
                                        <input type="text"
                                              name="info_name"
                                              :placeholder="$t('catalogProd.name')"
                                              v-validate="'required'"
                                              data-vv-scope="options"
                                              v-model="info.title"
                                              class="form-control">
                                        <small class="text-danger" v-if="errors.has('info_name')">
                                          {{ getError('info_name') }}
                                        </small>
                                      </div>
                                      <div class="form-group">
                                        <label class="pad-to-10">Description</label>
                                        <wysiwyg v-model="info.description" />
                                      </div>
                                    </el-collapse-item>
                                  </template>
                                </template>
                              </el-collapse>
                            </div>
                            <div class="col-md-12 pad-to-15 pad-bt-10">

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="currentSection === 'marketing'" id="marketing" class="card-container">
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <!--
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>{{$t('catalogProd.validFromTo')}}</label><br/>
                        <el-date-picker type="daterange" v-model="model.fromto"
                                            :name="pickerNames"
                                            :picker-options="pickerOptions1"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <small class="text-danger" v-show="date_from.invalid">
                          {{ getError('date_from') }}
                        </small>
                      </div>
                    </div> -->
                    <div class="col-md-12">
                      <!--   <h6>{{$t('catalogProd.prodType')}}</h6>
                            <hr class="sm">
                      <div class="form-group" >
                        <select name="type"
                                v-model="model.type"
                                class="form-control"
                                :disabled="!isNew()">
                          <option value="single">{{$t('catalogProd.singleType')}}</option>
                          <option value="group">{{$t('catalogProd.groupType')}}</option>
                        </select>
                        <small class="text-danger" v-if="errors.has('type')">
                          {{ getError('type') }}
                        </small>
                      </div> -->
                      <input type="hidden" name="" v-model="model.type" value="single">
                    </div>
                    <div class="col-md-12 ">
                      <div v-if="model.type == 'group'" >
                        <!-- <div class="col-md-12"> -->
                          <div class="form-group row">
                            <label class="col-md-12">Pick products that should be in the group</label>
                            <div class="col-md-12">
                            <v-select v-model="model.child_products"
                                      multiple
                                      :options="products"
                                      label="name"
                                    >
                            </v-select></div>
                            <small class="text-danger col-md-12" v-if="errors.has('child_products')">
                              {{ getError('child_products') }}
                            </small>
                          </div>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="col-md-12 pad-to-15">
                      <h6>
                        <img src="/static/img/icons/points-sm.png">
                        {{$t('catalogProd.rewardPoints')}}
                      </h6>
                      <hr class="sm">
                      <div class="form-group">
                        <label>{{$t('catalogProd.moneySpent')}}</label>
                        <small class="help-block">
                          {{$t('catalogProd.numberOfYouNeedToSpend', { currency: currency })}}
                          <div class="pad-to-5">{{$t('catalogProd.rewardPossibelValue')}}:
                            <ul>
                              <li>{{$t('catalogProdRewardsHints.hint1')}}</li>
                              <li>{{$t('catalogProdRewardsHints.hint2')}}</li>
                              <li>{{$t('catalogProdRewardsHints.hint3')}}</li>
                            </ul>
                          </div>
                        </small>
                        1 {{currency}} = <input type="number"
                              min="0"
                              step="0.1"
                              name="monetary_conversion"
                              v-model="model.monetary_conversion"
                              class="form-control in-inline"> {{$t('catalogProd.points')}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="prod-tabs" direction="horizontal" type="tabs">
                        <h6>{{$t('catalogProd.soldWith')}}</h6>
                        <hr class="sm">
                        <p-checkbox
                          v-model="model.sold_with_menu_suggestion"
                          :value="!!model.sold_with_menu_suggestion">
                          {{$t('catalogProd.sold_with_menu_suggestion')}}
                        </p-checkbox>
                        <p-checkbox
                          v-model="model.sold_with_menu_suggestion_pos"
                          :value="!!model.sold_with_menu_suggestion_pos">
                          {{$t('catalogProd.sold_with_menu_suggestion_pos')}}
                        </p-checkbox>
                        <div title="" tabId="first" class="text-left icon-search sold-with-tree" >
                          <input type="text" v-model="searchword" :placeholder="$t('general.search')" class="form-control " @input="search" />
                          <v-tree ref='tree' :data='treeData' :multiple='true' :allowGetParentNode='true' :halfcheck='true' @node-click="updateSoldWith" @node-check="updateSoldWith" @node-expand="getProductsForCategory"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="currentSection === 'label'" id="label" class="card-container">
            <div class="col-md-12">
              <div class="card">
                <div class="card-content">
                  <label class="control-label">{{ $t('catalogProd.orderLabelSettings') }}</label>
                  <div class="form-group label-input">
                    <label>{{ $t('catalogProd.printOnOrderLabel') }}</label>
                    <p-switch v-model="model.print_on_order_label" type="success"></p-switch>
                  </div>
                  <small class="help-block order-label-hint">{{ $t('catalogProd.printOnOrderLabelHint') }}</small>
                </div>
              </div>
            </div>
            <div class="col-md-8" v-if="model.labels">
              <div class="card">
                <div class="card-content">
                  <div class="form-group">
                    <label>{{$t('catalogProd.label_type')}}</label>
                    <select class="form-control"
                            v-model="model.labels[0].type"
                            >
                      <option selected :value="0">None</option>
                      <template v-for="lt in labelTypes">
                        <option :value="lt.id"
                        >{{ lt.name }}</option>
                      </template>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.label_name')}}</label>
                    <input type="text"
                          name="label_name"
                          :placeholder="$t('catalogProd.label_name')"
                          v-model="model.labels[0].name"
                          class="form-control">
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.label_ingredients')}}</label>
                    <input type="text"
                          name="label_ingredients"
                          :placeholder="$t('catalogProd.label_ingredients')"
                          v-model="model.labels[0].ingredients"
                          class="form-control">
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.label_allergens')}}</label>
                    <input type="text"
                          name="label_allergens"
                          :placeholder="$t('catalogProd.label_allergens')"
                          v-model="model.labels[0].allergens"
                          class="form-control">
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.label_exp_txt')}}</label>
                    <input type="text"
                          name="label_exp_txt"
                          :placeholder="$t('catalogProd.label_exp_txt')"
                          v-model="model.labels[0].exp_txt"
                          class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-if="model.labels">
              <div class="card" v-if="model.labels[0].type === 1">
                <div class="card-content">
                  <div class="prevewLabel">
                    <p class="prevewLabel_title" v-if="model.labels[0].name">{{model.labels[0].name}}</p>
                    <p class="prevewLabel_txt" v-if="model.labels[0].ingredients">{{model.labels[0].ingredients}}</p>
                    <p class="prevewLabel_txt" v-if="model.labels[0].allergens">{{model.labels[0].allergens}}</p>
                    <p class="prevewLabel_txt" v-if="model.labels[0].exp_txt">{{model.labels[0].exp_txt}}</p>
                    <p class="prevewLabel_title" >ORDER: NUMAR</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="currentSection === 'settings'" id="settings" class="card-container">
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isDeposit')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_deposit" type="success"></p-switch>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isAgeRestrict')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_age_restrict" type="success"></p-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.partialPay')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.partial_pay" type="success"></p-switch>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.limitQuantityKioskQr')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.limit_quantity_kiosk_qr" type="success"></p-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.highlightsProduct')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_highlight" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_highlight')">
                            {{ getError('is_highlight') }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isHiddenFromListing')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_hidden_from_listing" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_hidden_from_listing')">
                            {{ getError('is_hidden_from_listing') }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.allowUserComments')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.allow_user_comments" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('allow_user_comments')">
                            {{ getError('allow_user_comments') }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isHiddenFromSearch')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_hidden_from_search" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_hidden_from_search')">
                            {{ getError('is_hidden_from_search') }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.availableInStore')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_available_only_in_store" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_available_only_in_store')">
                            {{ getError('is_available_only_in_store') }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isHiddenFromQrMenu')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_hidden_from_qrmenu" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_hidden_from_qrmenu')">
                            {{ getError('is_hidden_from_qrmenu') }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isHiddenFromKiosk')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_hidden_from_kiosk" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_hidden_from_kiosk')">
                            {{ getError('is_hidden_from_kiosk') }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{$t('catalogProd.isHiddenFromPOS')}}</label>
                        <div class="pad-to-10">
                          <p-switch v-model="model.is_hidden_from_pos" type="success" ></p-switch>
                          <small class="text-danger" v-if="errors.has('is_hidden_from_pos')">
                            {{ getError('is_hidden_from_pos') }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="form-group row">
                    <label class="col-md-12">{{$t('catalogProd.taxes')}}</label>
                    <div class="col-md-12">
                      <v-select v-model="model.taxes"
                                  multiple
                                  :options="taxes"
                                  label="name">
                      </v-select></div>
                      <small class="text-danger" v-if="errors.has('taxes')">
                        {{ getError('taxes') }}
                      </small>
                  </div>
                  <div class="form-group" v-if="model && vatOptions && taxesVersion === 2">
                    <label>{{$t('catalogCateg.vat')}}</label>
                    <small>({{$t('catalogCateg.included')}})</small>
                    <select
                      v-model="model.vat_rate_id"
                      v-validate="modelValidations.vat_rate_id || {}"
                      data-vv-scope="settings"
                      class="form-control">
                      <option :value="null">{{ $t('vat.selectVat') }}</option>
                      <option
                        v-for="vat in vatOptions"
                        :key="vat.id"
                        :value="vat.id"
                        :disabled="isVatOptionDisabled(vat, model.vat_rate_id)"
                      >{{ vat.rate }}%<template v-if="!vat.is_active"> (inactiv)</template>
                      </option>
                    </select>
                  </div>
                  <div class="form-group" v-else-if="model && vatOptions">
                    <label>{{$t('catalogCateg.vat')}}</label>
                    <small>({{$t('catalogCateg.included')}})</small>
                    <select
                      @change="updateProductVatPrinterId($event)"
                      v-model="model.vat_id"
                      v-validate="modelValidations.vat_id || {}"
                      data-vv-scope="settings"
                      class="form-control">
                      <option :value="null">{{ $t('vat.selectVat') }}</option>
                      <option
                        v-for="vat in vatOptions"
                        :key="vat.id"
                        :value="vat.id"
                        :id="vat.id"
                        :data-amount="vat.amount"
                      >{{ vat.amount }} <template v-if="vat.tax && vat.tax.name"> - {{vat.tax.name}}</template>
                      </option>
                      <option style="display: none" :value="model.vat" v-if="model.vat !== null">{{ model.vat }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Taxe V2 aplicate</label>
                    <div v-if="taxesVersion !== 2" class="alert alert-warning">
                      <strong>Motorul Taxe V2 este oprit.</strong>
                      Atribuirile se salvează pentru migrare, dar aceste taxe nu se aplică până când activezi Taxe V2 pentru companie.
                    </div>
                    <el-select
                      v-model="model.tax_rule_ids_v2"
                      multiple
                      filterable
                      clearable
                      :loading="loadingProductTaxRules"
                      placeholder="Selectează una sau mai multe taxe"
                      style="width: 100%">
                      <el-option
                        v-for="rule in productTaxRuleOptions"
                        :key="rule.id"
                        :label="formatProductTaxRuleLabel(rule)"
                        :value="Number(rule.id)"
                        :disabled="isProductTaxRuleDisabled(rule)">
                      </el-option>
                    </el-select>
                    <small class="help-block">Poți adăuga sau scoate taxe, apoi salvezi produsul. Taxele inactive deja atribuite pot fi doar păstrate sau scoase.</small>
                    <div v-if="selectedProductTaxRules.length" class="table-responsive mar-to-10">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>Nume</th>
                            <th>Calcul</th>
                            <th>TVA taxă</th>
                            <th>Stare</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="rule in selectedProductTaxRules" :key="rule.id">
                            <td>{{ rule.name }}</td>
                            <td>{{ rule.value }}{{ rule.calculation_type === 'percentage' ? '%' : ' ' + currency }}</td>
                            <td>{{ rule.vat_rate ? rule.vat_rate.rate + '%' : '-' }}</td>
                            <td>
                              <span class="label" :class="productTaxRuleStatusClass(rule)">
                                {{ productTaxRuleStatusLabel(rule) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else class="help-block mar-to-10">Produsul nu are taxe V2 aplicate.</p>
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.posid')}}</label>
                    <input type="text"
                          name="pos_id"
                          :placeholder="$t('catalogProd.posid')"
                          v-model="model.pos_id"
                          class="form-control">
                  </div>
                  <div class="form-group">
                    <label>{{$t('catalogProd.externalProductId')}}</label>
                    <input
                      type="text"
                      name="external_product_id"
                      placeholder="1234, abcd-efgh"
                      v-model="model.external_product_id"
                      class="form-control">
                  </div>

                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card">
                <div class="card-content">
                  <div class="form-group">
                    <label>{{$t('catalogProd.max_purchases_per_customer')}}</label>
                    <input type="number"
                          name="max_purchases_per_customer"
                          :placeholder="$t('catalogProd.max_purchases_per_customer')"
                          v-model="model.max_purchases_per_customer"
                          class="form-control">
                  </div>
                  <div class="form-group">
                    <label>{{$t('settingCompany.purchase_limit_interval_hours')}}</label>
                    <input type="number"
                          name="purchase_limit_interval_hours"
                          :placeholder="$t('settingCompany.purchase_limit_interval_hours')"
                          v-model="model.purchase_limit_interval_hours"
                          class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>


      </form>
    </div>
    <div class="no-product-allowed" v-else>
      <h2> {{$t('catalogProd.accesRestricted')}} </h2>
    </div>
    <vmodal name="changeProductModal" height="600" width="900">
      <div class="card">
        <div class="card-content">
          <h4>{{$t('gestiune.changeProduct')}} - VAT {{ activeVat }}</h4>

          <input
            v-model="searchTerm"
            type="text"
            class="form-control"
            :placeholder="$t('gestiune.searchProduct')"
            @input="debouncedSearch"
          />

          <div class="search-results">
            <div :class="(loadingSearchProd ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <template v-if="searchResults && searchResults.length">
              <div
                v-for="prod in searchResults"
                :key="prod.id"
                class="search-item"
                :class="{ active: selectedProductForVat && selectedProductForVat._id === prod._id }"
                @click="selectProduct(prod)"
              >
                <div class="searchId">ID: {{ prod._id }}</div>
                {{ prod.name }} - <div style="display: inline;" v-html="showGestiuneCategory(prod.categorie)"></div>
                <span v-if="prod.reteta && prod.reteta.items && prod.reteta.items.length" class="reteta">Reteta</span>
              </div>
            </template>
            <template v-else>
              <p class="centerSearch">{{$t('general.no_data')}}</p>
            </template>
          </div>

          <div class="modal-footer">
            <button class="btn btnSearch btn-danger" @click="$modal.hide('changeProductModal')">{{$t('general.close')}}</button>
            <button class="btn btnSearch btn-success" @click="saveNewLink">{{$t('general.save')}}</button>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select, Option} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import vSelect from 'vue-select'
  import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  import VTree from 'vue-tree-halower'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import 'vue-wysiwyg/dist/vueWysiwyg.css'
  import VueDropdown from 'src/components/UIComponents/Inputs/VatDropdown.vue'
  Vue.component('v-select', vSelect)
  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(VTree)
  Vue.use(VueDropdown)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      PSwitch,
      VueDropdown
    },
    props: {
      mainCategoriesParent: {
        type: Array,
        required: true
      },
      // productsParent: {
      //   type: Array,
      //   required: true
      // },
      // productsGroupedParent: {
      //   required: true
      // },
      productOptionsParent: {
        required: true
      },
      companyProductFilters: {
        required: true
      },
      taxesParent: {
        type: Array,
        required: true
      },
      kdsSectionsParent: {
        type: Array,
        required: true
      },
      // callback: {
      //   required: true
      // },
      // callbackDelete: {
      //   required: true
      // },
      measurementsUnits: {
        required: true
      },
      language: {
        required: true
      },
      languages: {
        required: true
      },
      route: {
        type: Object,
        default: () => ({})
      }
    },
    watch: {
      mainCategoriesParent (value, oldVal) {
        this.mainCategories = value
      },
      // productsParent (value, oldVal) {
      //   this.products = value
      // },
      // productsGroupedParent (value, oldVal) {
      //   this.productsGrouped = value
      //   this.getTrees()
      // },
      productOptionsParent (value, oldVal) {
        this.productOptions = value
        this.$nextTick(function () {
          this.filterOptionsByLocations()
          this.availableFiltersByLocations()
        })
      },
      taxesParent (value, oldVal) {
        this.taxes = value
      },
      kdsSectionsParent (value) {
        Vue.set(this, 'kdsSections', value)
      },
      'model.override_delivery': {
        handler: function (newval, oldval) {
          // this.updateDeliverySettings(this.model, this.model.location_ids)
        },
        deep: true
      },
      'model.location_ids': {
        handler: function (newval, oldval) {
          this.$nextTick(function () {
            // this.updateDeliverySettings(this.model, newval)
            this.clampCoursesType()
          })
        },
        deep: true
      },
      coursesTypeMax () {
        this.clampCoursesType()
      }
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity']),
      selectedProductTaxRules () {
        const selectedIds = (this.model && Array.isArray(this.model.tax_rule_ids_v2))
          ? this.model.tax_rule_ids_v2.map(id => Number(id))
          : []
        const availableRules = []
          .concat(this.productTaxRuleOptions || [])
          .concat((this.model && this.model.tax_rules_v2) || [])
        const rulesById = {}
        availableRules.forEach(rule => {
          rulesById[Number(rule.id)] = rule
        })
        return selectedIds.map(id => rulesById[id]).filter(rule => !!rule)
      },
      hasProductOptionsWithoutCompanyOptions () {
        const hasProductOptions = this.model && Array.isArray(this.model.product_options) && this.model.product_options.length > 0
        const hasCompanyOptions = Array.isArray(this.productOptions) && this.productOptions.length > 0
        return hasProductOptions && !hasCompanyOptions
      },
      preparationTimeInMinutes: {
        get () {
          if (this.model.preparation_time_in_seconds === null || this.model.preparation_time_in_seconds === undefined || this.model.preparation_time_in_seconds === '') {
            return null
          }
          return Number(this.model.preparation_time_in_seconds) / 60
        },
        set (minutes) {
          if (minutes === null || minutes === undefined || minutes === '') {
            this.$set(this.model, 'preparation_time_in_seconds', null)
            return
          }
          this.$set(this.model, 'preparation_time_in_seconds', Math.round(Number(minutes) * 60))
        }
      },
      selectedCategory () {
        if (!this.model.category_id) {
          return null
        }
        const categoryId = parseInt(this.model.category_id, 10)
        const fromList = this.mainCategories.find(cat => parseInt(cat.id, 10) === categoryId)
        if (fromList) {
          return fromList
        }
        if (this.model.category && parseInt(this.model.category.id, 10) === categoryId) {
          return this.model.category
        }
        return null
      },
      categoryPreparationTimeInMinutes () {
        const category = this.selectedCategory
        if (!category) {
          return null
        }
        const seconds = category.preparation_time_in_seconds
        if (seconds === null || seconds === undefined || seconds === '') {
          return null
        }
        return Number(seconds) / 60
      },
      mainCategoriesForSecondaryCategories () {
        return this.mainCategories.map(cat => {
          return {
            id: cat.id,
            name: cat.name
          }
        })
      },
      timeSelectOptions () {
        const options = []
        let h = 0
        let m = 0
        while (h < 24) {
          options.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`)
          m += 15
          if (m >= 60) {
            m -= 60
            h += 1
          }
        }
        options.push('23:59')
        return options
      },
      coursesTypeMax () {
        const defaultMax = 5
        const selectedLocations = (this.model && this.model.location_ids && this.model.location_ids.length)
          ? this.model.location_ids
          : this.locations

        if (!selectedLocations || !selectedLocations.length) {
          return defaultMax
        }

        const counts = selectedLocations.map(loc => {
          const locationId = loc.id || loc
          const locationData = this.locations[this.getObjectByElemKeyValue('id', locationId, this.locations)]
          const rawValue = locationData ? locationData.pos_default_course_count : null

          if (rawValue === null || rawValue === undefined || rawValue === '') {
            return defaultMax
          }

          const count = parseInt(rawValue, 10)
          return isNaN(count) ? defaultMax : count
        })

        return Math.min(...counts)
      },
      coursesTypeHasError () {
        if (this.errors.has('courses_type', 'general')) {
          return true
        }
        if (this.model.courses_type === null || this.model.courses_type === '') {
          return false
        }
        const value = Number(this.model.courses_type)
        return !isNaN(value) && (value < 0 || value > this.coursesTypeMax)
      },
      coursesTypeErrorMessage () {
        if (this.coursesTypeMax === 0) {
          return this.$t('catalogProd.coursesTypeLocationNotPermitted')
        }
        return this.$t('catalogProd.coursesTypeMaxAllowed', { max: this.coursesTypeMax })
      },
      modelValidations () {
        const validations = { ...this.baseValidations }
        // kds_section_id required doar dacă există kdsSectionsParent și are elemente
        if (this.kdsSectionsParent && this.kdsSectionsParent.length > 0) {
          validations.kds_section_id = {
            required: true
          }
        }
        // TVA-ul este obligatoriu pe câmpul motorului activ.
        if (this.vatOptions && this.vatOptions.length > 0) {
          validations[this.taxesVersion === 2 ? 'vat_rate_id' : 'vat_id'] = {
            required: true
          }
        }
        validations.courses_type = {
          required: false,
          min_value: 0,
          max_value: this.coursesTypeMax
        }
        return validations
      }
    },
    data () {
      return {
        loadingSearchProd: false,
        linkedProducts: {},
        loadingVat: null,
        activeVat: null,
        optionValueQuery: '',
        searchTerm: '',
        searchResults: [],
        selectedProductForVat: null,
        searchTimeout: null,
        // locationModified: false,
        // use_auto: {},

        companyID: null,
        taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
        productTaxRuleOptions: [],
        initialProductTaxRuleIds: [],
        loadingProductTaxRules: false,
        use_gestiune: false,
        has_charisma_location: false,
        administrations: [],
        administrationsToDelete: [],
        charismaLocations: [],
        pricesFor: [
          {
            id: 1,
            name: 'Website'
          },
          {
            id: 2,
            name: 'QR'
          },
          {
            id: 3,
            name: 'Kiosk'
          },
          {
            id: 4,
            name: 'POS'
          },
          {
            id: 5,
            name: 'GLOVO'
          },
          {
            id: 6,
            name: 'BOLT'
          },
          {
            id: 7,
            name: 'Wolt'
          }
        ],
        invalidTabs: [],
        overrideDeliveryErrors: [],
        currentSection: 'description',
        currentSubSection: 'l1',
        validateOptionCheck: true,
        type: '',
        isCheckedDeliveryMethod: false,
        isCheckedDay: false,
        pickerOptions1: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        imagesToBeDeleted: [],
        groupOptions: [],
        tabIndex: null,
        tabFilterIndex: null,
        tabOtherInfoIndex: null,
        currentTab: '',
        pickerNames: ['date_from', 'date_to'],
        mainCategories: this.mainCategoriesParent,
        model: [],
        soldWithProducts: [],
        products: [],
        productsGrouped: [],
        halfChecks: [],
        productOptions: this.productOptionsParent,
        productAvailableFilters: [],
        productOptionsFiltered: [],
        taxes: [],
        labelTypes: [
          {
            id: 1,
            name: 'Eticheta 6x4cm'
          }
        ],
        hasImages: false,
        showLocations: false,
        locations: [],
        prevLocationIds: [],
        orderingManagement: [],
        is_not_available_from: '',
        is_not_available_to: '',
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        selectedVideo: null,
        baseValidations: {
          name: {
            required: true,
            min: 3
          },
          sku: {
            required: true
          },
          measurements_units_id: {
            required: true
          },
          quantitative_unit: {
            required: false,
            min_value: 0,
            max_value: 9999999.99
          },
          price: {
            required: true,
            min_value: 0,
            max_value: 999999.99
          },
          price_to_show: {
            required: false,
            min_value: 0,
            max_value: 999999.99
          },
          old_price: {
            min_value: 0,
            required: true
          },
          category_id: {
            required: true
          }
        },
        optionTypes: ['checkbox', 'radio'],
        searchword: '',
        kdsSections: [],
        searchwordExtra: '',
        treeData: [],
        treeDataExtra: [],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        use_pos_id_per_product_option: this.$session.get('selectedCompanyData')['use_pos_id_per_product_option'] || 0,
        use_quantity_per_product_option: this.$session.get('selectedCompanyData')['use_quantity_per_product_option'] || 0,
        loading: true,
        userRole: null,
        filtersData: [],
        isNewFilter: false,
        filter: {
          value: null,
          filter_id: null,
          showError: false
        },
        initialStatus: null,
        // filters: [],
        errorProductUnavailable: null,
        nullProductOptionValues: false,
        vatOptions: null,
        deleteOptionValues: [],
        deleteOptions: [],
        deleteOverrides: []
      }
    },
    created: function () {
      this.companyID = this.$session.get('selectedCompany')
      this.$bus.$on('doReloadProd', this.doReloadProd)
      let companyData = this.$session.get('selectedCompanyData')
      this.use_gestiune = companyData.use_gestiune
      this.ensureCompanyLocationFlags((sessionData) => {
        this.has_charisma_location = !!sessionData.has_charisma_location
      })
      this.initCharismaAdministrations()
      this.loadProductTaxRules()
      this.getData()
      this.model.allowed_location = true
      if (this.$session.get('userDataRole') !== 'LOCATION_STORE_ADMIN') {
        this.locations = companyData.locations_details
        if (this.locations.length > 1) {
          this.showLocations = true
        }
      }
      this.userRole = this.$session.get('userDataRole')
      // this.orderingManagement = companyData.ordering_management
      if (this.locations.length > 1) {
        this.showLocations = true
      }
      if (!this.productsGrouped.length) {
        this.getCategories()
      }
      this.getProductFiltersCount()
      this.getTrees()
      this.getGroupOptions()
    },
    mounted () {
      this.mapItems()
    },
    methods: {
      loadProductTaxRules () {
        this.loadingProductTaxRules = true
        this.apiRequest('/taxes-v2/rules', 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }, (response) => {
          this.loadingProductTaxRules = false
          if (response.status === true && Array.isArray(response.data)) {
            this.productTaxRuleOptions = response.data
              .filter(rule => rule.applies_to === 'item')
              .sort((a, b) => String(a.name).localeCompare(String(b.name)))
          }
        })
      },
      formatProductTaxRuleLabel (rule) {
        const value = rule.calculation_type === 'percentage'
          ? rule.value + '%'
          : rule.value + ' ' + this.currency
        return rule.name + ' (' + value + ')' + (rule.is_active ? '' : ' - inactivă')
      },
      isProductTaxRuleDisabled (rule) {
        if (rule.is_active) {
          return false
        }
        return this.initialProductTaxRuleIds.indexOf(Number(rule.id)) === -1
      },
      productTaxRuleStatusLabel (rule) {
        if (this.taxesVersion !== 2) return 'Nu se aplică — motor V2 oprit'
        return rule.is_active ? 'Se aplică' : 'Nu se aplică — taxă inactivă'
      },
      productTaxRuleStatusClass (rule) {
        return this.taxesVersion === 2 && rule.is_active ? 'label-success' : 'label-default'
      },
      showGestiuneCategory (category) {
        const colors = {
          'Produs finit (Reteta)': '#674BD2',
          'Marfa': 'orange',
          'Fara Categorie': 'gray'
        }

        if (!category || category.trim() === '') {
          category = 'Fara Categorie'
        }

        const color = colors[category] || 'gray'

        return `<span class="searchBadge" style="background: ${color}">${category}</span>`
      },
      async loadLinkedProducts () {
        for (const vat in this.model.pos_id_gruped_by_vat) {
          const entries = this.model.pos_id_gruped_by_vat[vat]
          if (!entries.length) continue

          const posId = entries[0].pos_id

          this.loadingVat = vat

          if (posId) {
            try {
              const response = await fetch(
                `${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator`,
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    posId: posId,
                    externalCompanyId: this.companyID,
                    vatNumber: vat
                  })
                }
              )

              const data = await response.json()

              if (response.ok && data) {
                this.$set(this.linkedProducts, vat, data)
              }
            } catch (e) {
              console.error(e)
            }
          }

          this.loadingVat = null
        }
      },

      async openChangeModal (vat) {
        this.activeVat = vat
        this.searchTerm = ''
        this.searchResults = []
        this.selectedProductForVat = null

        this.$modal.show('changeProductModal')
        if (!this.searchResults.length) {
          this.loadingSearchProd = true
          await this.searchProducts()
        }
      },

      debouncedSearch () {
        this.loadingSearchProd = true
        clearTimeout(this.searchTimeout)

        this.searchTimeout = setTimeout(() => {
          this.searchProducts()
        }, 400)
      },

      async searchProducts () {
        // if (!this.searchTerm) return

        const params = {
          externalCompanyId: this.companyID,
          vatNumber: this.activeVat,
          name: this.searchTerm,
          page: 1,
          limit: 50,
          category: 'Produs finit (Reteta), Marfa, fara_categorie'
        }

        const queryString = new URLSearchParams(params).toString()
        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?${queryString}`

        const response = await fetch(url)
        const data = await response.json()
        this.loadingSearchProd = false
        if (data.products) {
          this.searchResults = data.products.map(p => ({ ...p }))
        }
      },

      selectProduct (prod) {
        this.selectedProductForVat = prod
      },

      async removeGestionLink (vat) {
        // this.selectedProductForVat = this.model.pos_id_gruped_by_vat[vat][0];
        this.selectedProductForVat = null
        this.activeVat = vat
        this.saveNewLink()
      },

      async saveNewLink () {
        const vat = this.activeVat
        let posId = null

        if (this.selectedProductForVat) {
          posId = this.selectedProductForVat._id
        }

        if (this.isNew()) {
          this.model.pos_id_gruped_by_vat[vat].forEach(item => {
            item.pos_id = posId
            item.is_manual = 1
          })
          if (this.selectedProductForVat) {
            this.$set(this.linkedProducts, vat, { ...this.selectedProductForVat })
          } else {
            this.$set(this.linkedProducts, vat, null)
          }
          this.$modal.hide('changeProductModal')
          return true
        }

        if (this.selectedProductForVat) {
          this.model.pos_id_gruped_by_vat[vat].forEach(item => {
            item.pos_id = this.selectedProductForVat._id
            item.is_manual = 1
          })
          this.$set(this.linkedProducts, vat, { ...this.selectedProductForVat })
        }

        // var data = {
        //   token: this.$session.get('token'),
        //   company_id: this.$session.get('selectedCompany'),
        //   product_id: this.model.id,
        //   vat: vat,
        //   locations_ids: locationsIds,
        //   pos_id: posId
        // }
        // this.apiRequest('/gestiune/update-product-pos-link', 'POST', data, (response) => {
        //   if (response.status === true) {
        //     if (this.selectedProductForVat) {
        //       this.model.pos_id_gruped_by_vat[vat].forEach(item => {
        //         item.pos_id = this.selectedProductForVat._id
        //       })
        //       this.$set(this.linkedProducts, vat, { ...this.selectedProductForVat })
        //     } else {
        //       this.model.pos_id_gruped_by_vat[vat].forEach(item => {
        //         item.pos_id = null
        //       })
        //       this.$set(this.linkedProducts, vat, null)
        //     }
        //   }
        // })

        this.$modal.hide('changeProductModal')
      },

      async getPosIdGrupedByVat () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/gestiune/get-pos-id-gruped-by-vat', 'POST', data, (response) => {
          if (response.status === true) {
            this.model.pos_id_gruped_by_vat = response.data.pos_id_gruped_by_vat
          }
        })

        this.$modal.hide('changeProductModal')
      },

      addNewOverrideInterval (locId, deliveryMethod, deliveryMethodLabel) {
        if (!this.model.override_settings[locId]['delivery'][deliveryMethod]) {
          Vue.set(this.model.override_settings[locId]['delivery'], deliveryMethod, [])
        }
        this.model.override_settings[locId]['delivery'][deliveryMethod].push(
          this.createEmptyOverrideInterval(deliveryMethodLabel)
        )
      },

      // Remove an interval by index for a given delivery method
      removeOverrideInterval (locId, deliveryMethod, intervalIndex) {
        if (this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id) {
          this.deleteOverrides.push(this.model.override_settings[locId]['delivery'][deliveryMethod][intervalIndex].id)
        }
        this.model.override_settings[locId]['delivery'][deliveryMethod].splice(intervalIndex, 1)
      },
      validateOption (option, keyId) {
        this.validateOptionCheck = true
        if (option.values.length && option.max_no > parseInt(option.values.length)) {
          this.errors.add('max' + keyId, this.$t('catalogProd.maxNoTooHigh'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'max' + keyId)
          }
        }

        if (parseInt(option.min_no) > parseInt(option.max_no) && parseInt(option.max_no)) {
          this.errors.add('min' + keyId, this.$t('catalogProd.minNoTooHigh'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'min' + keyId)
          }
        }

        if (parseInt(option.min_no) < 0) {
          this.errors.add('min_negative' + keyId, this.$t('catalogProd.minNoNegative'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'min_negative' + keyId)
          }
        }

        if (parseInt(option.max_no) < 0) {
          this.errors.add('max_negative' + keyId, this.$t('catalogProd.maxNoNegative'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'max_negative' + keyId)
          }
        }
      },
      removeDiacritics (str) {
        return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      },
      filterOptionValues (query) {
        this.optionValueQuery = query
      },
      resetOptionValueQuery (visible) {
        if (visible) {
          this.optionValueQuery = ''
        }
      },
      matchesOptionValueQuery (name, selectedId, optionId) {
        if (optionId === selectedId) {
          return true
        }
        const query = this.removeDiacritics(this.optionValueQuery).toLowerCase().trim()
        if (!query) {
          return true
        }
        return this.removeDiacritics(name).toLowerCase().indexOf(query) > -1
      },
      selectOptionValue (selectedId, optionIndex, optionValueIndex) {
        const option = this.model.product_options[optionIndex]
        const companyOptionIndex = this.getObjectByElemKeyValue('id', option.company_option_id, this.productOptionsFiltered)
        let selectedName = ''
        if (companyOptionIndex !== false && this.productOptionsFiltered[companyOptionIndex] && this.productOptionsFiltered[companyOptionIndex]['values']) {
          const values = this.productOptionsFiltered[companyOptionIndex]['values']
          const valueIndex = this.getObjectByElemKeyValue('id', selectedId, values)
          if (valueIndex !== false && values[valueIndex]) {
            selectedName = values[valueIndex].name
          }
        }
        Vue.set(this.model.product_options[optionIndex].values[optionValueIndex], 'name', selectedName)
        Vue.set(this.model.product_options[optionIndex].values[optionValueIndex], 'company_option_value_id', selectedId)

        // Clear POS-related fields when option value changes
        if (this.model.product_options &&
          this.model.product_options[optionIndex] &&
          this.model.product_options[optionIndex].values &&
          this.model.product_options[optionIndex].values[optionValueIndex]
        ) {
          Vue.set(this.model.product_options[optionIndex].values[optionValueIndex], 'pos_id', '')

          if (this.use_pos_id_per_product_option || this.model.product_options[optionIndex].values[optionValueIndex].hasOwnProperty('pos_id_per_product')) {
            Vue.set(this.model.product_options[optionIndex].values[optionValueIndex], 'pos_id_per_product', '')
          }
        }
      },
      updateProductVatPrinterId (obj) {
        let selectElement = obj.target
        selectElement = selectElement.options[selectElement.selectedIndex]
        if (selectElement) {
          const selectedAmount = selectElement.dataset.amount
          this.model.vat = selectedAmount
        }
      },
      getVatOptions (locaitonIds = null) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        const endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat'
        this.apiRequest(endpoint, 'GET', data, (response) => {
          if (response.status === true) {
            Vue.set(this, 'vatOptions', response.data)
            // this.vatOptions = response.data
          }
        })
      },
      isVatOptionDisabled (vat, selectedId) {
        return !!(this.taxesVersion === 2 && vat && !vat.is_active && String(vat.id) !== String(selectedId))
      },
      getTaxOption (locaitonIds) {
        let locationIds = locaitonIds
        if (Array.isArray(locationIds) && locationIds.length && typeof locationIds[0] === 'object') {
          locationIds = locationIds
            .map(loc => loc && (loc.id != null ? loc.id : loc.location_id))
            .filter(id => id != null && id !== '')
        }
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locationIds
        }
        this.apiRequest('/location/taxes', 'GET', data, (response) => {
          if (response.status === true && Array.isArray(response.data) && response.data.length) {
            Vue.set(this, 'taxes', response.data)
          }
        })
      },
      getGroupOptions () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/group-options', 'GET', data, (response) => {
          if (response.status === true) {
            this.groupOptions = response.data
          }
        })
      },
      handleCheckDay (locId, intervalId, orderId) {
        let check = this.model.override_settings[locId]['delivery'][intervalId][orderId]['active'] &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].monday &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].tuesday &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].wednesday &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].thursday &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].friday &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].saturday &&
        !this.model.override_settings[locId]['delivery'][intervalId][orderId].sunday

        this.isCheckedDay = !check

        if (!this.isCheckedDay && this.model.override_delivery) {
          this.errors.add('isCheckedDay', 'Day is required.')
          return false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(element => {
              return element.field !== 'isCheckedDay'
            })
          }
        }
      },
      handleChangeIsCheckedDeliveryMethod (locId, orderIntervalId, orderId) {
        let hasActive = false
        const delivery = this.model.override_settings[locId]['delivery']
        const groups = Array.isArray(delivery) ? delivery : Object.values(delivery || {})
        groups.forEach((group) => {
          if (Array.isArray(group)) {
            group.forEach((interval) => {
              if (interval && (interval.active === true || interval.active === 1)) {
                hasActive = true
              }
            })
          } else if (group && (group.active === true || group.active === 1)) {
            hasActive = true
          }
        })

        this.isCheckedDeliveryMethod = !hasActive
        this.handleChangeOverrideDelivery()
        if (orderIntervalId !== undefined && orderId !== undefined) {
          this.handleCheckDay(locId, orderIntervalId, orderId)
        }
      },
      handleChangeOverrideDelivery () {
        if (this.isCheckedDeliveryMethod && this.model.override_delivery) {
          this.errors.add('isCheckedDeliveryMethod', 'Location is required.')
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(element => {
              return element.field !== 'isCheckedDeliveryMethod'
            })
          }
        }
      },
      createEmptyOverrideInterval (deliveryMethod) {
        return {
          active: true,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          delivery_method: deliveryMethod,
          available_from: '',
          available_to: ''
        }
      },
      deliveryMethodLabel (orderInterval, orderIntervalId) {
        if (orderInterval && orderInterval[0] && orderInterval[0].delivery_method) {
          return orderInterval[0].delivery_method
        }
        return orderIntervalId
      },
      getLocationOrderingManagement (loc) {
        if (loc && Array.isArray(loc.ordering_management) && loc.ordering_management.length) {
          return loc.ordering_management
        }

        const allTypes = (this.$session.get('defaultData') || {}).delivery_types || {}
        const methods = []

        if (Array.isArray(allTypes)) {
          allTypes.forEach((type) => {
            const method = typeof type === 'string' ? type : (type && (type.key || type.type))
            if (method) {
              methods.push({ type: String(method).toLowerCase() })
            }
          })
        } else if (allTypes && typeof allTypes === 'object') {
          Object.keys(allTypes).forEach((key) => {
            methods.push({ type: String(key).toLowerCase() })
          })
        }

        if (!methods.length) {
          return [
            { type: 'pick_up' },
            { type: 'delivery' },
            { type: 'eat_in' }
          ]
        }

        return methods
      },
      buildLocationDeliveryMap (loc, existingDelivery) {
        let delivery = {}

        // Keep only real intervals that already exist (from API or user-added)
        if (Array.isArray(existingDelivery)) {
          existingDelivery.forEach((group) => {
            if (!Array.isArray(group) || !group.length || !group[0] || !group[0].delivery_method) {
              return
            }
            const method = group[0].delivery_method
            delivery[method] = group.slice()
          })
        } else if (existingDelivery && typeof existingDelivery === 'object') {
          Object.keys(existingDelivery).forEach((method) => {
            const group = existingDelivery[method]
            delivery[method] = Array.isArray(group) ? group.slice() : []
          })
        }

        // Ensure method buckets exist so the + button is available, but do not seed empty rows
        const orderingManagement = this.getLocationOrderingManagement(loc)
        orderingManagement.forEach((ordering) => {
          const deliveryMethod = ordering.type
          if (!deliveryMethod) {
            return
          }
          if (!Object.prototype.hasOwnProperty.call(delivery, deliveryMethod)) {
            delivery[deliveryMethod] = []
          }
        })

        return delivery
      },
      overrideLocationTitle (locId) {
        const idx = this.getObjectByElemKeyValue('id', locId, this.locations)
        if (idx === false || !this.locations[idx]) {
          return locId
        }
        return this.locations[idx].name
      },
      getCategories () {
        if (this.productsGrouped.length) {
          this.productsGrouped = []
        } else {
          const groupData = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sold_with_products: this.model.sold_with_products
          }
          if (this.model.location_ids && this.model.location_ids.length) {
            let ids = []
            for (let index = 0; index < this.model.location_ids.length; index++) {
              ids.push(this.model.location_ids[index].id)
            }
            groupData.location_ids = ids
          }
          this.apiRequest('/product-tree-categories', 'GET', groupData, response => {
            if (response.status === true) {
              this.productsGrouped = response.data.data
              this.halfChecks = (response.data.half_checks || []).map(id => parseInt(id))
              this.getTrees()
            }
          })
        }
      },
      updateSoldWith (node, checked, position) {
        if (position.level === 1) {
          const categoryId = parseInt(node.id)
          const wasPartial = this.halfChecks.includes(categoryId) || node.children.some(child => child.checked)
          const categoryIndex = this.model.sold_with_categories.indexOf(categoryId)
          if (!checked && categoryIndex !== -1) {
            this.model.sold_with_categories.splice(categoryIndex, 1)
          }
          if (checked && categoryIndex === -1) {
            this.model.sold_with_categories.push(categoryId)
          }
          this.halfChecks = this.halfChecks.filter(id => id !== categoryId)
          if (node.children.length) {
            this.removeChildrenFromSoldWithProducts(node)
          } else if (wasPartial) {
            const data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              category_id: categoryId,
              category_name: node.title
            }
            this.apiRequest('/product-tree-category-products', 'GET', data, response => {
              if (response.status) {
                this.removeChildrenFromSoldWithProducts({children: response.data.products})
                this.getTrees()
              }
            })
          }
        }

        if (position.level === 2) {
          const parent = node.parent()
          const parentId = parseInt(parent.id)
          const categoryIndex = this.model.sold_with_categories.indexOf(parentId)
          const checkedChildren = parent.children.filter(child => child === node ? checked : child.checked)
          const productId = parseInt(node.id)
          const productIndex = this.model.sold_with_products.findIndex(id => parseInt(id) === productId)
          if (!checked && productIndex !== -1) {
            this.model.sold_with_products.splice(productIndex, 1)
          }
          if (checked && productIndex === -1) {
            this.model.sold_with_products.push(productId)
          }

          if (checkedChildren.length === parent.children.length && this.searchword.length < 3) {
            if (categoryIndex === -1) {
              this.model.sold_with_categories.push(parentId)
            }
            this.removeChildrenFromSoldWithProducts(parent)
          } else if (!checked && categoryIndex !== -1) {
            this.model.sold_with_categories.splice(categoryIndex, 1)
            checkedChildren.forEach(child => {
              const childId = parseInt(child.id)
              if (!this.model.sold_with_products.some(id => parseInt(id) === childId)) {
                this.model.sold_with_products.push(childId)
              }
            })
          }
          this.halfChecks = this.halfChecks.filter(id => id !== parentId)
          if (checkedChildren.length && !this.model.sold_with_categories.includes(parentId)) {
            this.halfChecks.push(parentId)
          }
        }
      },
      getProductsForCategory (node, expand, position) {
        if (!node.children.length) {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            category_id: parseInt(node.id),
            category_name: node.title
          }

          if (this.searchword.length >= 3) {
            data.search = this.searchword
          }

          if (this.model.location_ids.length) {
            let ids = []
            for (let index = 0; index < this.model.location_ids.length; index++) {
              ids.push(this.model.location_ids[index].id)
            }
            data.location_ids = ids
          }

          this.apiRequest('/product-tree-category-products', 'GET', data, (response) => {
            if (response.status) {
              let categoryId = response.data.category_id
              this.productsGrouped[categoryId].items = response.data.products
              this.getTrees(categoryId, expand)
            }
          })
        } else {
          for (var index = 0; index < this.treeData.length; index++) {
            this.treeData[index].expanded = false
            this.treeData[index].hasExpanded = false
          }
          this.treeData[position.index].expanded = expand
          this.treeData[position.index].hasExpanded = expand
        }
      },
      removeChildrenFromSoldWithProducts (node) {
        for (const child of node.children) {
          const index = this.model.sold_with_products.findIndex(id => parseInt(id) === parseInt(child.id))
          if (index !== -1) {
            this.model.sold_with_products.splice(index, 1)
          }
        }
      },
      search () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        if (this.searchword.length >= 3) {
          if (this.model.location_ids.length) {
            let ids = []
            for (let index = 0; index < this.model.location_ids.length; index++) {
              ids.push(this.model.location_ids[index].id)
            }
            data.location_ids = ids
          }

          data.search = this.searchword
          this.apiRequest('/product-tree-search', 'GET', data, (response) => {
            if (response.status === true) {
              this.productsGrouped = response.data
              this.getTrees()
            }
          })
        }

        if (this.searchword.length === 0) {
          data.sold_with_products = this.model.sold_with_products
          this.apiRequest('/product-tree-categories', 'GET', data, response => {
            if (response.status === true) {
              this.productsGrouped = response.data.data
              this.halfChecks = (response.data.half_checks || []).map(id => parseInt(id))
              this.getTrees()
            }
          })
        }
      },
      filterSecondaryCategories () {
        this.mainCategories.filter(
          cat => this.model.secondary_categories.includes(cat.id)
        )
      },
      clampCoursesType () {
        if (!this.model || this.model.courses_type == null || this.model.courses_type === '') {
          return
        }
        if (this.model.courses_type > this.coursesTypeMax) {
          this.model.courses_type = this.coursesTypeMax
        }
      },
      validateCoursesType () {
        this.$validator.validate('courses_type', 'general')
      },
      productFilterValues (filter) {
        const filterById = this.getObjectByElemKeyValue('id', filter.id, this.productAvailableFilters)
        return this.productAvailableFilters[filterById]
      },
      isNew () {
        if (this.route.params.id && this.route.params.id !== 'add') {
          this.type = this.$t('general.edit')
          return false
        } else {
          this.type = this.$t('general.add')
          this.model.allowed_location = true
          return true
        }
      },
      getData () {
        this.imagesToBeDeleted = []
        this.$nextTick(function () {
          this.loading = true
        })
        this.errors['items'] = this.removeErrorByName('error', this.errors['items'])
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        var objProps = ['taxes', 'tax_rules_v2', 'sold_with_products', 'sold_with_categories', 'extra_products', 'extra_categories', 'product_options', 'location_ids']
        // get product data
        if (this.route.params.id && this.route.params.id !== 'add') {
          var prodId = this.route.params.id

          this.apiRequest('/product/' + prodId, 'GET', data, (response) => {
            if (response.status === true) {
              // self.getFilters()
              // self.getProductFilters()
              // if (response.data[0].date_validfrom && response.data[0].date_validto) {
              //   response.data[0].fromto = [response.data[0].date_validfrom, response.data[0].date_validto]
              // }
              if (response.data[0].image_url) {
                response.data[0].imagelist = response.data[0].image_url
                this.hasImages = response.data[0].images.length > 0
              } else {
                response.data[0].imagelist = []
              }
              if (response.data[0].more_image_url) {
                response.data[0].moreimagelist = response.data[0].more_image_url
              } else {
                response.data[0].moreimagelist = []
              }
              for (var prop in objProps) {
                if (response.data[0][objProps[prop]] === undefined || response.data[0][objProps[prop]] === null) {
                  response.data[0][objProps[prop]] = []
                }
              }
              const assignedTaxRuleIds = response.data[0].tax_rules_v2.map(rule => Number(rule.id))
              this.$set(response.data[0], 'tax_rule_ids_v2', assignedTaxRuleIds)
              this.initialProductTaxRuleIds = assignedTaxRuleIds.slice()
              if (response.data[0].category.id !== undefined) {
                response.data[0].category_id = response.data[0].category.id
              }
              if (response.data[0].delivery_details !== undefined || response.data[0].delivery_details !== null) {
                for (var existingLocation in response.data[0].delivery_details) {
                  if (response.data[0].delivery_details[existingLocation].delivery !== undefined || response.data[0].delivery_details[0].delivery !== null) {
                    for (var existingDay in response.data[0].delivery_details[0].delivery) {
                      if (response.data[0].delivery_details[0].delivery[existingDay].days === undefined || response.data[0].delivery_details[0].delivery[existingDay].days === null) {
                        response.data[0].delivery_details[0].delivery[existingDay].days = {
                          'Monday': false,
                          'Tuesday': false,
                          'Wednesday': false,
                          'Thursday': false,
                          'Friday': false,
                          'Saturday': false,
                          'Sunday': false
                        }
                      }
                    }
                  }
                }
              }
              this.model = response.data[0]
              this.$set(this.model, 'print_on_order_label', !!this.model.print_on_order_label)
              this.model.override_delivery = !!(
                this.model.override_delivery === true ||
                this.model.override_delivery === 1 ||
                this.model.override_delivery === '1'
              )
              if (!Array.isArray(this.model.override_settings)) {
                this.model.override_settings = []
              }
              this.deleteOverrides = []
              if (!this.model.administrations) {
                this.model.administrations = []
              }
              this.mapLocationIdsToObjects()
              if (!this.model.labels || !this.model.labels.length) {
                this.model.labels = [
                  {
                    id: 0,
                    type: '',
                    name: '',
                    ingredients: '',
                    allergens: '',
                    exp_txt: ''
                  }
                ]
              }
              if (Array.isArray(this.model.localized_fields) && this.model.localized_fields.length === 0) {
                this.model.localized_fields = {}
              }
              this.languages.forEach((element, index) => {
                if (!this.model.localized_fields[element.short]) {
                  this.model.localized_fields[element.short] = {
                    language_id: element.id,
                    name: '',
                    description: '',
                    language_short: element.short,
                    language_name: element.name
                  }
                }
              })
              this.pricesFor.forEach((element, index) => {
                if (!this.model.price_list[element.id]) {
                  this.model.price_list[element.id] = {
                    id: 0,
                    price: null,
                    price_for: element.id
                  }
                }
              })
              if (!this.model.image_size) {
                this.model.image_size = 'cover'
              }
              this.initialStatus = this.model.active
              this.prevLocationIds = response.data[0]['location_ids'] ? [...response.data[0]['location_ids']] : []
              if (!this.model.secondary_categories) {
                this.model.secondary_categories = []
              }
              this.getCategories()
              this.getTrees()
              this.filterOptionsByLocations()
              this.availableFiltersByLocations()
              this.getVatOptions(this.model.locations)
              this.getTaxOption(this.model.locations)
              this.loadLinkedProducts()

              if (this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN') {
                this.locations = this.model.store_admin_locations
                if (this.locations.length > 1) {
                  this.showLocations = true
                }
              }
              this.updateDeliverySettings()
              this.$nextTick(function () {
                this.clampCoursesType()
                this.loading = false
              })
            }
          })
        } else {
          this.model = []
          let object = {
            'taxes': [],
            'vat_rate_id': null,
            'tax_rules_v2': [],
            'tax_rule_ids_v2': [],
            'secondary_categories': [],
            'courses_type': null,
            'sold_with_products': [],
            'sold_with_categories': [],
            'sold_with_menu_suggestion_pos': null,
            'extra_products': [],
            'extra_categories': [],
            'product_options': [],
            'product_filters': [],
            'location_ids': [],
            'discountPeriod': [],
            'price_list': {},
            'localized_fields': {},
            'image_size': 'cover',
            'is_discounted': false,
            'old_price': null,
            'new_price': null,
            'valid_from': null,
            'valid_to': null,
            'active': true,
            'print_on_order_label': false,
            'is_age_restrict': false,
            'type': 'single',
            'administrations': [],
            'override_delivery': false,
            'override_settings': []
          }
          object.labels = [
            {
              id: 0,
              type: '',
              name: '',
              ingredients: '',
              allergens: '',
              exp_txt: ''
            }
          ]
          this.languages.forEach((element, index) => {
            if (!object.localized_fields[element.short]) {
              object.localized_fields[element.short] = {
                language_id: element.id,
                name: '',
                description: '',
                language_short: element.short,
                language_name: element.name
              }
            }
          })
          this.pricesFor.forEach((element, index) => {
            if (!object.price_list[element.id]) {
              object.price_list[element.id] = {
                id: 0,
                price: null,
                price_for: element.id
              }
            }
          })
          this.model = object
          this.getVatOptions(this.model.locations)
          this.getTaxOption(this.model.locations)
          this.getPosIdGrupedByVat()

          this.$nextTick(function () {
            this.loading = false
          })
        }
        this.currency = this.getCurrencySymbol(this.currency)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      // Marks the base ('l1') and per-language translation tabs red when the name
      // is missing. Returns the first incomplete sub-tab id (or null if all filled).
      validateLocalizedNames () {
        let firstInvalidSub = null

        if (!this.model.name || !String(this.model.name).trim()) {
          if (!this.invalidTabs.includes('l1')) {
            this.invalidTabs.push('l1')
          }
          firstInvalidSub = 'l1'
        }

        if (Array.isArray(this.languages)) {
          this.languages.forEach((lang) => {
            const lf = this.model.localized_fields ? this.model.localized_fields[lang.short] : null
            const tabKey = lang.id + '-' + lang.short
            if (!lf || !lf.name || !String(lf.name).trim()) {
              if (!this.invalidTabs.includes(tabKey)) {
                this.invalidTabs.push(tabKey)
              }
              if (!firstInvalidSub) {
                firstInvalidSub = tabKey
              }
            }
          })
        }

        return firstInvalidSub
      },
      async validate () {
        this.errors['items'] = this.removeErrorByName('error', this.errors['items'])

        const initStatus = !!parseInt(this.initialStatus)
        const actualStatus = !!parseInt(this.model.active)

        if ((!this.model.is_not_available_from || !this.model.is_not_available_to) && this.model.is_not_available) {
          this.errorProductUnavailable = this.$t('catalogProd.productNotAvailableError')
          return false
        } else {
          this.errorProductUnavailable = null
        }

        const scopes = ['description', 'general', 'price', 'location', 'options', 'marketing', 'settings']
        this.invalidTabs = []
        let overallValid = true
        let firstInvalidScope = null

        for (const scope of scopes) {
          const isScopeValid = await this.$validator.validateAll(scope)
          if (!isScopeValid) {
            this.invalidTabs.push(scope)
            if (!firstInvalidScope) {
              firstInvalidScope = scope
            }
            overallValid = false
          }
        }

        this.nullProductOptionValues = false
        if (this.model.product_options) {
          this.model.product_options.forEach((element, index) => {
            if (!element.values.length) {
              this.nullProductOptionValues = true
              overallValid = false
              if (!firstInvalidScope) {
                firstInvalidScope = 'options'
              }
              if (!this.invalidTabs.includes('options')) {
                this.invalidTabs.push('options')
              }
            }
          })
        }

        // Override delivery validation
        this.overrideDeliveryErrors = []
        if (this.model.override_delivery && this.model.override_settings && this.model.override_settings.length) {
          const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
          let hasAnyInterval = false
          let hasMissingHours = false
          let hasMissingDay = false

          for (const locSetting of this.model.override_settings) {
            if (!locSetting.delivery) continue
            for (const deliveryMethod in locSetting.delivery) {
              const intervals = locSetting.delivery[deliveryMethod]
              if (intervals.length > 0) {
                hasAnyInterval = true
                for (const interval of intervals) {
                  if (!interval.available_from || !interval.available_to) {
                    hasMissingHours = true
                  }
                  if (!days.some(d => interval[d])) {
                    hasMissingDay = true
                  }
                }
              }
            }
          }

          if (!hasAnyInterval) {
            this.overrideDeliveryErrors.push(this.$t('validations.noOverrideIntervals'))
          } else {
            if (hasMissingHours) {
              this.overrideDeliveryErrors.push(this.$t('validations.overrideIntervalMissingHours'))
            }
            if (hasMissingDay) {
              this.overrideDeliveryErrors.push(this.$t('validations.overrideIntervalMissingDay'))
            }
          }

          if (this.overrideDeliveryErrors.length) {
            overallValid = false
            if (!this.invalidTabs.includes('location')) {
              this.invalidTabs.push('location')
            }
            if (!firstInvalidScope) {
              firstInvalidScope = 'location'
            }
          }
        }

        if (this.has_charisma_location && this.model.administrations && this.model.administrations.length) {
          this.model.administrations.forEach((row, index) => {
            const fieldName = `administration_id_${index}`
            this.errors.remove(fieldName)
            if (!row.administration_id) {
              this.errors.add({
                field: fieldName,
                msg: this.$t('validations.requiredField')
              })
              overallValid = false
              if (!firstInvalidScope) {
                firstInvalidScope = 'description'
              }
              if (!this.invalidTabs.includes('description')) {
                this.invalidTabs.push('description')
              }
            }
          })
        }

        const firstInvalidLocalizedTab = this.validateLocalizedNames()
        if (firstInvalidLocalizedTab) {
          overallValid = false
          if (!this.invalidTabs.includes('description')) {
            this.invalidTabs.push('description')
          }
          if (!firstInvalidScope) {
            firstInvalidScope = 'description'
          }
          this.currentSubSection = firstInvalidLocalizedTab
        }

        if (overallValid) {
          if (initStatus && !actualStatus) {
            this.checkBanner(this.model.id)
          } else {
            this.initialStatus = this.model.active
            this.saveProduct()
          }
        } else {
          this.currentSection = firstInvalidScope || 'general'
          // console.warn('Formular invalid. Prima secțiune cu erori:', this.currentSection);
        }
      },
      handleVatInputChange () {
        if (!Number.isInteger(this.model.vat)) {
          this.model.vat = Math.floor(this.model.vat)
        }
        if (this.model.vat < 0 || this.model.vat > 100) {
          this.model.vat = 0
        }
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors[prop].length === 1) {
            this.errors.add(prop, errors[prop][0])
          } else {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      handleVideoThumbChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload_video_thumbnail.clearFiles()
          this.model.video_thumbnail = []
        } else {
          if (fileList.length > 1) {
            this.model.video_thumbnail = fileList.slice(1)
          } else {
            this.model.video_thumbnail = fileList
          }
        }
        this.getBase64(this.model.video_thumbnail[0].raw).then((base64enc) => {
          this.model.video_thumbnail[0].base64enc = base64enc
        })
      },
      handleVideoThumbRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.video_thumbnail = []
        }
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      handleVideoChange (event) {
        if (event.target.files[0].size > 5097152) {
          alert('File is too big!')
          this.selectedVideo = null
        } else {
          this.selectedVideo = event.target.files[0]
        }
      },
      handleMoreImgChnage (file, moreFileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.moreimagelist = []
        } else {
          this.model.moreimagelist = moreFileList
        }
      },
      handleMoreRemove (file, moreFileList) {
        this.imagesToBeDeleted.push(file)
        if (moreFileList.length === 0) {
          this.model.moreimagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      backButton () {
        if (this.route.path && this.route.path.includes('/integrations/menu-fix')) {
          window.close()
          return
        }
        this.$bus.$emit('refresh', this.route.params.id)
        this.$bus.$emit('close-modal', null, this.route.params.id)
      },
      beforeUpload (file) {
        var self = this
        const isOkSize = file.size / 1024 / 1024 < 5
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      mapItems () {
        for (var i in this.products) {
          let idx = this.getObjectByElemKeyValue('id', parseInt(this.products[i].id), this.model.sold_with_products)
          if (idx) {
            this.soldWithProducts.push(this.products[i])
          }
        }
      },
      getTrees (expendNodeId = null, expandParam = null) {
        this.treeData = []

        var currentProdID = null
        if (!this.isNew()) {
          currentProdID = parseInt(this.route.params.id)
        }

        this.$nextTick(function () {
          var catProdTree = []
          this.treeData = []
          let expand = false

          for (var id in this.productsGrouped) {
            if (expendNodeId && parseInt(expendNodeId) === parseInt(id)) {
              if (expandParam) {
                expand = expandParam
              }
            } else {
              expand = false
            }
            let idCateg = this.isInObject(parseInt(id), this.model.sold_with_categories)
            if (idCateg) {
              let data = {'id': id, 'title': this.productsGrouped[id].details.name, 'checked': true}
              let children = []
              for (let idx in this.productsGrouped[id].items) {
                let title = this.productsGrouped[id].items[idx].name
                title += this.productsGrouped[id].items[idx].locations.length !== 0 ? ' (' + Object.values(this.productsGrouped[id].items[idx].locations) + ')' : ' (' + this.$t('general.all') + ')'
                if (currentProdID !== this.productsGrouped[id].items[idx].id) {
                  children.push({'id': this.productsGrouped[id].items[idx].id, 'title': title, 'checked': true})
                }
              }
              data['children'] = children
              data['expanded'] = expand
              catProdTree.push(data)
            } else {
              // handle children
              let children = []
              for (let idx in this.productsGrouped[id].items) {
                let chk = false
                let idProd = this.isInObject(parseInt(this.productsGrouped[id].items[idx].id), this.model.sold_with_products)
                if (idProd) {
                  chk = true
                }
                let title = this.productsGrouped[id].items[idx].name
                title += this.productsGrouped[id].items[idx].locations.length !== 0 ? ' (' + Object.values(this.productsGrouped[id].items[idx].locations) + ')' : ' (' + this.$t('general.all') + ')'
                if (currentProdID !== this.productsGrouped[id].items[idx].id) {
                  children.push({
                    'id': this.productsGrouped[id].items[idx].id,
                    'title': title,
                    'checked': chk
                  })
                }
              }
              let isHalfcheck = children.length
                ? children.some(child => child.checked)
                : this.halfChecks.includes(parseInt(id))
              catProdTree.push({'id': id, 'title': this.productsGrouped[id].details.name, 'expanded': expand, 'children': children, 'halfcheck': isHalfcheck, 'checked': false})
            }
          }
          this.treeData = catProdTree
        })
      },
      addNewOption () {
        // 'type': 'radiobox',
        // 'name': '',
        // 'modified': false,
        let newRow = {
          'id': null,
          'min_no': null,
          'max_no': null,
          'required': true,
          'hide_prices': false,
          'has_default_value': false,
          'active': true,
          'values': []
        }

        this.model.product_options.push(newRow)

        this.tabIndex = this.model.product_options ? this.model.product_options.length - 1 : 0
      },
      addNewOptionValue (optIdx) {
        let newRow = {
          'id': null,
          'active': true,
          'price': null
        }
        if (this.use_pos_id_per_product_option) {
          newRow['pos_id_per_product'] = 0
        }
        if (this.use_quantity_per_product_option) {
          newRow['quantity_per_option'] = 0
        }
        this.model.product_options[optIdx].values.push(newRow)
      },
      showAddButton (optIdx, option) {
        if (option === undefined) {
          return false
        }
        if (option['id'] === undefined) {
          return false
        }
        var existingOptions = option['values'].length
        var allOptions = this.productOptions[this.getObjectByElemKeyValue('id', option['company_option_id'], this.productOptions)]
        if (allOptions === undefined) {
          return false
        }
        allOptions = allOptions['values'].length
        return existingOptions < allOptions
      },
      disableOption (optIdx, id, main) {
        // let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisOptIdx = false
        if (main) {
          if (this.model.product_options !== undefined) {
            thisOptIdx = this.getObjectByElemKeyValue('company_option_id', id, this.model.product_options)
          }
        } else {
          if (this.model.product_options[optIdx] !== undefined) {
            thisOptIdx = this.getObjectByElemKeyValue('company_option_value_id', id, this.model.product_options[optIdx]['values'])
          }
        }

        if (thisOptIdx !== false) {
          return true
        } else {
          return false
        }
      },
      deleteOption (thisOptIdx) {
        var self = this
        swal({
          text: self.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            self.deleteOptions.push(this.model.product_options[thisOptIdx].id)
            self.model.product_options.splice(thisOptIdx, 1)
          }
        })
      },
      deleteOptionValue (thisOptIdx, thisValIdx) {
        this.deleteOptionValues.push(this.model.product_options[thisOptIdx].values[thisValIdx].id)
        this.model.product_options[thisOptIdx].values.splice(thisValIdx, 1)
      },
      updateName (thisOptIdx, optId, optName) {
        let prOptIdx = this.getObjectByElemKeyValue('id', optId, this.productOptions)
        if (this.productOptions[prOptIdx]['name'] === optName) {
          this.model.product_options[thisOptIdx]['modified'] = false
        } else {
          this.model.product_options[thisOptIdx]['modified'] = true
        }
      },
      getOptData (option, what) {
        if (option.company_option_id) {
          let prOptIdx = this.getObjectByElemKeyValue('id', option.company_option_id, this.productOptions)
          if (prOptIdx) {
            return this.productOptions[prOptIdx].label ? this.productOptions[prOptIdx][what] + ' (' + this.productOptions[prOptIdx].label + ')' : this.productOptions[prOptIdx][what]
          }
        }
        switch (what) {
          case 'name': return this.$t('catalogProdOpt.new')
          default: return null
        }
      },
      changeOption (thisOptIdx, companyOptionId) {
        if (companyOptionId) {
          let companyOptionIndex = this.getObjectByElemKeyValue('id', companyOptionId, this.productOptions)
          let companyOption = this.productOptions[companyOptionIndex]
          this.model.product_options[thisOptIdx]['values'] = []
          this.model.product_options[thisOptIdx]['type'] = companyOption['type']
          this.model.product_options[thisOptIdx]['name'] = companyOption['name']
          this.model.product_options[thisOptIdx]['company_option_id'] = companyOption['id']
          this.model.product_options[thisOptIdx]['required'] = true
          this.model.product_options[thisOptIdx]['hide_prices'] = false
          this.model.product_options[thisOptIdx]['has_default_value'] = false
          this.tabIndex = thisOptIdx
        }
      },
      // search () {
      //   this.$refs.tree.searchNodes(this.searchword)
      // },
      searchExtra () {
        this.$refs.treeExtra.searchNodes(this.searchwordExtra)
      },
      handleDelete (label) {
        var self = this

        var productData = {
          token: self.$session.get('token'),
          company_id: self.$session.get('selectedCompany'),
          product_id: self.route.params.id
        }
        self.apiRequest('/check-banner-has-product', 'GET', productData, function (response) {
          if (response && response.data && response.data.product_banner) {
            productData.active = 0
            productData.id = response.data.banner_id

            swal({
              text: self.$t('catalogProd.deleteProductUsedByBanner'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: self.$t('general.yes'),
              cancelButtonText: self.$t('general.no'),
              onOpen: () => {
                swal.enableConfirmButton()
              }
            }).then((result) => {
              if (result) {
                self.apiRequest('/banner/' + productData.id, 'PUT', productData, function (response2) {
                  if (response2.status) {
                    self.deleteProduct(label)
                  } else {
                    swal(
                      '',
                      self.$t('validations.wentWrong'),
                      'error'
                    ).catch(() => {})
                  }
                })
              }
            })
          } else {
            self.deleteProduct(label)
          }
        })
      },
      deleteProduct (label) {
        var self = this
        var btnCounter = 3
        swal({
          text: self.$t('validations.areYouSureYouWantTo') + ` ` + label + `?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            if (self.isNew()) {
              // self.router.push('/products')
              self.$bus.$emit('refresh')
              self.$bus.$emit('close-modal')
            } else {
              var id = self.route.params.id
              var data = {
                id: id,
                token: self.$session.get('token'),
                company_id: self.$session.get('selectedCompany')
              }
              self.apiRequest('/product/' + id, 'DELETE', data, function (response) {
                if (response.status === true) {
                  self.trackAdminEvent('ADMIN_PRODUCT_DELETED', 'product', id, {
                    product_id: id,
                    name: (self.model && self.model.name) || null,
                    location_ids: (self.model && self.model.location_ids) || null
                  })
                  swal(
                    '',
                    self.$t('catalogProd.prodDeleted'),
                    'success'
                  )
                  // self.callbackDelete()
                  // self.router.push('/products')
                  self.$bus.$emit('refresh')
                  self.$bus.$emit('close-modal')
                } else {
                  swal(
                    '',
                    self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      checkBanner (productId) {
        var productData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          product_id: productId
        }
        var self = this

        self.apiRequest('/check-banner-has-product', 'GET', productData, function (response) {
          if (response && response.data && response.data.product_banner) {
            productData.active = 0
            productData.id = response.data.banner_id

            swal({
              text: self.$t('catalogProd.disableProductUsedByBanner'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: self.$t('general.yes'),
              cancelButtonText: self.$t('general.no')
            }).then((result) => {
              if (result) {
                self.initialStatus = self.model.active
                self.apiRequest('/banner/' + productData.id, 'PUT', productData, function (response2) {
                  if (response2.status) {
                    swal(
                      self.$t('general.success') + '!',
                      '',
                      'success'
                    ).catch(() => {})
                  } else {
                    swal(
                      '',
                      self.$t('validations.wentWrong'),
                      'error'
                    ).catch(() => {})
                  }
                  self.saveProduct()
                })
              }
            }, function (dismiss) {
              if (dismiss === 'cancel') {
                return false
              }
            })
          } else {
            self.saveProduct()
          }
        })
      },
      removeVideo (id) {
        this.loading = true
        const formData = new FormData()
        formData.append('token', this.$session.get('token'))
        formData.append('product_id', id)
        formData.append('company_id', this.$session.get('selectedCompany'))
        this.apiRequest('/product-remove-video', 'POST', formData, (response) => {
          if (response.status) {
            swal({
              title: '',
              text: 'Video remove successfully',
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            }).catch(() => {})
            if (this.$refs.video && this.$refs.video.value) {
              this.$refs.video.value = null
            }
            this.selectedVideo = null
            this.getData()
          } else {
            swal({
              title: '',
              text: 'Video error',
              type: 'error',
              showConfirmButton: false,
              timer: 1500
            }).catch(() => {})
          }
          this.loading = false
        })
      },
      uploadVideo (id) {
        if (this.selectedVideo) {
          this.loading = true
          const formData = new FormData()
          formData.append('token', this.$session.get('token'))
          formData.append('product_id', id)
          formData.append('company_id', this.$session.get('selectedCompany'))
          formData.append('video', this.selectedVideo)
          formData.append('video_name', this.selectedVideo.name)
          this.apiRequest('/product-upload-video', 'POST', formData, (response) => {
            if (response.status) {
              swal({
                title: '',
                text: 'Video saved successfully',
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }).catch(() => {})
              this.$refs.video.value = null
              this.getData()
            } else {
              swal({
                title: '',
                text: 'Video error',
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }).catch(() => {})
            }
            this.loading = false
          })
        }
      },
      saveProduct (videoData = null, bypassPreCheckSaveProduct = null) {
        this.$nextTick(() => {
          this.loading = true
        })
        var self = this
        this.apiRequest('/product/pre-check-save-product', 'POST', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: this.model.id,
          new_name: this.model.name
        }, (pcspResp) => {
          if (!bypassPreCheckSaveProduct && pcspResp && pcspResp.status && pcspResp.data.sameNameAreYouShoure) {
            swal({
              text: self.$t('catalogProd.same_name_are_you_shore'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: self.$t('general.continue'),
              cancelButtonText: self.$t('general.cancel')
            })
            .then((result) => {
              if (result) {
                self.saveProduct(videoData, 1)
                // nothing, continue with save
              } else {
                self.loading = false
                return 0
              }
            }, function (dismiss) {
              if (dismiss === 'cancel') {
                self.loading = false
                return 0
              }
            })
            self.loading = false
            return 0
          }

          this.model.sold_with_menu_suggestion = !!this.model.sold_with_menu_suggestion
          this.model.limit_quantity_kiosk_qr = !!this.model.limit_quantity_kiosk_qr
          this.model.is_age_restrict = !!this.model.is_age_restrict

          // manage options values prices first
          if (this.model.product_options && this.model.product_options.length) {
            for (let optIdx in this.model.product_options) {
              if (this.model.product_options[optIdx]['values'].length) {
                for (let optValIdx in this.model.product_options[optIdx]['values']) {
                  let valPrc = this.model.product_options[optIdx]['values'][optValIdx]['price']
                  if (valPrc === null || valPrc === '') {
                    this.model.product_options[optIdx]['values'][optValIdx]['price'] = null
                  }
                }
              }
            }
          }

          if (this.model.override_settings && this.model.override_settings.length) {
            this.model.override_settings.forEach(item => {
              item.version = 2
            })
          }

          this.model.override_delivery = !!(
            this.model.override_delivery === true ||
            this.model.override_delivery === 1 ||
            this.model.override_delivery === '1'
          )

          var data = this.copyObject(this.model)
          // Atribuirile V2 pot fi pregatite inainte de activarea motorului.
          // copyObject turns arrays into plain objects, so read the ids from the model.
          const taxRuleIdsV2 = Object.values(this.model.tax_rule_ids_v2 || {})
          data.tax_rule_ids_v2 = JSON.stringify(taxRuleIdsV2.map(id => Number(id)))
          if (this.taxesVersion === 2) {
            delete data.vat_id
            delete data.vat
            delete data.taxes
          } else {
            delete data.vat_rate_id
          }
          delete data.tax_rules_v2
          delete data.delivery_details
          // let datacopy = this.model
          data.token = this.$session.get('token')
          data.company_id = this.$session.get('selectedCompany')

          // if (this.model['fromto'] !== undefined && this.model['fromto'] && this.model['fromto'][0] && this.model['fromto'][1]) {
          //   data.date_validfrom = this.model['fromto'][0]
          //   data.date_validto = this.model['fromto'][1]
          // } else {
          data.date_validfrom = null
          data.date_validto = null
          data.valid_to = data.valid_to === {} ? null : data.valid_to
          data.valid_from = data.valid_from === {} ? null : data.valid_from
          // }
          // if (data.vat === 'null') {
          //   data.vat = null
          //   data.vat_id = null
          // }
          if (data.type === 'single') {
            delete data.child_products
          } else {
            data.child_products = JSON.stringify(data.child_products)
          }
          // delete data.fromto
          delete data.other_images
          // sanitaze product oprion object
          // if (data.product_options) {
          //   for (let optIdx in data.product_options) {
          //     // delete data.product_options[optIdx].type
          //     // delete data.product_options[optIdx].name
          //     delete data.product_options[optIdx].modified
          //     delete data.product_options[optIdx].show_in_total_price
          //     if (data.product_options[optIdx]['values']) {
          //       for (let optValIdx in data.product_options[optIdx]['values']) {
          //         delete data.product_options[optIdx]['values'][optValIdx].price_details
          //         // delete data.product_options[optIdx]['values'][optValIdx].label
          //       }
          //     }
          //   }
          // }
          // Validate product filters
          if (data.product_filters) {
            for (let filIdx in data.product_filters) {
              if (data.product_filters[filIdx]['filter_id'] === 0) {
                swal({
                  title: '',
                  text: self.$t('filter.filterType') + ' ' + self.$t('general.required'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }).catch(() => {})
                self.$nextTick(function () { self.loading = false })
                return false
              }
              if (Object.keys(data.product_filters[filIdx]['filter_value']).length === 0) {
                swal({
                  title: '',
                  text: 'Filter values is required',
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }).catch(() => {})
                self.$nextTick(function () { self.loading = false })
                return false
              }
            }
          }

          data.product_options = JSON.stringify(data.product_options)
          data.product_filters = JSON.stringify(data.product_filters)

          data.delete_option_values = this.deleteOptionValues
          data.delete_options = this.deleteOptions
          data.delete_overrides = this.deleteOverrides

          var objProps = ['taxes']
          for (var prop in objProps) {
            if (data[objProps[prop]] === undefined || data[objProps[prop]] === null) {
            } else {
              if (data[objProps[prop]] === []) {
                data[objProps[prop]] = JSON.stringify(data[objProps[prop]])
              } else {
                var vals = []
                var objs = data[objProps[prop]]
                for (var ii in objs) {
                  vals.push(objs[ii].id)
                }
                data[objProps[prop]] = JSON.stringify(vals)
              }
            }
          }

          // let categs = []
          // let prods = []
          // for (let idx in this.treeData) {
          //   if (this.treeData[idx]['checked'] !== undefined && this.treeData[idx]['checked'] === true && (this.treeData[idx]['halfcheck'] === false || this.treeData[idx]['halfcheck'] === undefined)) {
          //     categs.push(this.treeData[idx]['id'])
          //   } else {
          //     for (let idxChild in this.treeData[idx]['children']) {
          //       if (this.treeData[idx]['children'][idxChild] && this.treeData[idx]['children'][idxChild]['checked'] === true) {
          //         prods.push(this.treeData[idx]['children'][idxChild]['id'])
          //       }
          //     }
          //   }
          // }
          data['sold_with_products'] = JSON.stringify(this.model.sold_with_products)
          data['sold_with_categories'] = JSON.stringify(this.model.sold_with_categories)

          let locIds = []
          for (let idxL in data.location_ids) {
            locIds.push(data.location_ids[idxL]['id'])
          }
          data['location_ids'] = JSON.stringify(locIds)
          // check for delivery details hour from and to for avoid be array
          for (var existingLocation in data.delivery_details) {
            for (var method in data.delivery_details[existingLocation].delivery) {
              if (typeof data.delivery_details[existingLocation].delivery[method].from !== 'undefined' && (data.delivery_details[existingLocation].delivery[method].from === '' || typeof data.delivery_details[existingLocation].delivery[method].from === 'object')) {
                data.delivery_details[existingLocation].delivery[method].from = null
              }
              if (typeof data.delivery_details[existingLocation].delivery[method].to !== 'undefined' && (data.delivery_details[existingLocation].delivery[method].to === '' || typeof data.delivery_details[existingLocation].delivery[method].to === 'object')) {
                data.delivery_details[existingLocation].delivery[method].to = null
              }
            }
          }
          data['delivery_details'] = JSON.stringify(data.delivery_details)

          if (this.has_charisma_location) {
            if (this.model.administrations && this.model.administrations.length) {
              data.administrations = this.model.administrations.map(admin => ({
                ...admin,
                location_ids: admin.location_ids.map(loc => (typeof loc === 'object' ? loc.id : loc))
              }))
            }
            if (!this.isNew()) {
              data.administrationsToDelete = this.administrationsToDelete
            }
          }

          let makeNull = ['monetary_conversion', 'description', 'sku', 'pos_id']
          for (let field of makeNull) {
            if (typeof data[field] !== 'undefined' && (data[field] === '' || typeof data[field] === 'object')) {
              data[field] = null
            }
          }

          if (this.isNew()) {
            delete data.image
            // data.use_auto = this.use_auto
            this.apiRequest('/product', 'POST', data, function (response) {
              if (response.status === true) {
                // self.locationModified = false
                self.model.product_options = response.data[0].product_options
                self.model.other_info = response.data[0].other_info
                var id = response.data[0].id
                self.prepareMorePicturesForSave(data).then((saveData) => {
                  const hasImages = saveData.image || saveData.use === 'forMorePictures'

                  const showCreateSuccess = () => {
                    self.$nextTick(function () { self.loading = false })
                    swal(
                      {
                        title: '',
                        text: self.$t('catalogProd.prodAdded'),
                        type: 'success',
                        showConfirmButton: false,
                        timer: 1500
                      }
                    ).catch(() => {})
                    self.$bus.$emit('refresh')
                    self.$bus.$emit('close-modal')
                  }

                  const showCreatePhotoError = () => {
                    self.$nextTick(function () { self.loading = false })
                    swal(
                      {
                        title: '',
                        text: self.$t('catalogProd.prodPhotoError'),
                        type: 'danger',
                        showConfirmButton: false,
                        timer: 1500
                      }
                    ).catch(() => {})
                  }

                  if (hasImages) {
                    const pictureData = {
                      id: id,
                      token: data.token,
                      company_id: data.company_id
                    }
                    if (saveData.image) {
                      pictureData.image = saveData.image
                    }
                    if (saveData.use === 'forMorePictures') {
                      pictureData.use = saveData.use
                      pictureData.imagesToBeDeleted = saveData.imagesToBeDeleted
                      pictureData.allPictures = saveData.allPictures
                    }
                    self.apiRequest('/product/' + id, 'PUT', pictureData, function (response2) {
                      if (response2.status === true) {
                        showCreateSuccess()
                      } else {
                        showCreatePhotoError()
                      }
                    })
                  } else {
                    showCreateSuccess()
                  }
                })
              } else {
                self.$nextTick(function () { self.loading = false })
                self.handleErrors(response.errors)
              }
            })
          } else {
            var id = this.route.params.id
            delete data.parent_category
            delete data.images
            delete data.image_url
            delete data.created_at
            delete data.created_by
            delete data.updated_at
            delete data.updated_by
            delete data.deleted_at
            delete data.deleted_by
            delete data.company
            delete data.parent_product
            delete data.top_category
            delete data.category
            delete data.price_details
            delete data.extra_categories
            delete data.extra_products
            // check if the've removed the picture
            if (!data.imagelist) {
              data.imagelist = []
            }
            if (!self.model.imagelist) {
              self.model.imagelist = []
            }
            if (!data.imagelist[0]) {
              data.images = ''
            }
            let nowHasImages = data.imagelist && !!data.imagelist[0]
            data.image_was_removed = (self.hasImages && !nowHasImages)
            delete data.imagelist
            if (this.selectedVideo) {
              this.uploadVideo(id)
            }
            self.prepareMorePicturesForSave(data).then((saveData) => {
              self.apiRequest('/product/' + id, 'PUT', saveData, function (response) {
                if (response.status === true) {
                  self.trackAdminEvent('ADMIN_PRODUCT_UPDATE', 'product', id, {
                    product_id: id,
                    name: (self.model && self.model.name) || null,
                    active: !!(self.model && self.model.active),
                    location_ids: (self.model && self.model.location_ids) || null,
                    request: saveData,
                    response: response
                  })
                  const deletedOptionIds = saveData.delete_options || self.deleteOptions || []
                  if (deletedOptionIds.length) {
                    deletedOptionIds.forEach((optId) => {
                      self.trackAdminEvent('ADMIN_PRODUCT_OPTION_DELETED', 'product_option', optId, {
                        product_option_id: optId,
                        product_id: id
                      })
                    })
                  }
                  if (saveData.allPictures && saveData.allPictures.length) {
                    self.getData()
                  }
                  // self.locationModified = false
                  self.model.product_options = response.data[0].product_options
                  self.model.other_info = response.data[0].other_info
                  self.model.tax_rules_v2 = response.data[0].tax_rules_v2 || []
                  const savedTaxRuleIds = self.model.tax_rules_v2.map(rule => Number(rule.id))
                  self.$set(self.model, 'tax_rule_ids_v2', savedTaxRuleIds)
                  self.initialProductTaxRuleIds = savedTaxRuleIds.slice()
                  self.model.price_list = response.data[0].price_list
                  self.pricesFor.forEach((element, index) => {
                    if (!self.model.price_list[element.id]) {
                      self.model.price_list[element.id] = {
                        id: 0,
                        price: null,
                        price_for: element.id
                      }
                    }
                  })
                  self.$bus.$emit('updateProductInList', id, {
                    name: self.model.name,
                    price: self.model.price,
                    is_discounted: self.model.is_discounted,
                    active: self.model.active,
                    locations: response.data[0].locations,
                    delivery: response.data[0].delivery
                  })
                  if (!self.selectedVideo) {
                    self.$nextTick(function () { self.loading = false })
                  }
                  swal(
                    {
                      title: '',
                      text: self.$t('catalogProd.prodUpdated'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    }
                  ).catch(() => {})
                } else {
                  if (!self.selectedVideo) {
                    self.$nextTick(function () { self.loading = false })
                  }
                  self.handleErrors(response.errors)
                }
              }) // end api response
            })
          }
        })
      },
      prepareMorePicturesForSave (data) {
        const allPromises = []
        for (const imgKey in this.model.moreimagelist) {
          const img = this.model.moreimagelist[imgKey]
          if (img && img.status === 'ready') {
            allPromises.push(this.getBase64(img.raw))
          }
        }

        let mainImagePromise = Promise.resolve(null)
        if (this.model.imagelist && this.model.imagelist[0] && this.model.imagelist[0].status === 'ready') {
          mainImagePromise = this.getBase64(this.model.imagelist[0].raw)
        }

        return Promise.all([Promise.all(allPromises), mainImagePromise]).then(([allPictures, mainImageBase64]) => {
          if (allPictures.length || this.imagesToBeDeleted.length) {
            data.use = 'forMorePictures'
            data.imagesToBeDeleted = this.imagesToBeDeleted
            data.allPictures = allPictures
          }
          if (mainImageBase64) {
            data.image = mainImageBase64
          }
          return data
        })
      },
      changeGroupOptions () {
        // console.log('changeGroupOptions')
      },
      // onLocationModified () {
      //   this.locationModified = true
      // },
      checkLocations (model) {
        // validate locations first
        this.$nextTick(function () {
          let self = this
          let location = self.model.location_ids
          let ok = true
          let badIds = []
          for (let loc of location) {
            // let prevLocKey = this.getObjectByElemKeyValue('id', loc.id, this.prevLocationIds)
            if (self.model.product_options.length) {
              // location is a new one, make sure is ok for the selected options
              for (let prOpt of self.model.product_options) {
                let optIdx = this.getObjectByElemKeyValue('id', prOpt.id, self.model.product_options)
                let optionLocations = self.model.product_options[optIdx]['location_ids']
                if (optionLocations === undefined || !optionLocations || !optionLocations.length) {
                  // all ok
                } else {
                  // check if loc.id is in the set locs of this option
                  if (optionLocations.indexOf(loc.id) === -1) {
                    // option is not ok for this location
                    ok = false
                    badIds.push(loc.id)
                    // continue
                  }
                }
              }
            }
          }
          // show error if needed
          if (!ok) {
            var btnCounter = 3

            swal({
              text: self.$t('catalogProd.addLocationValidation'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: self.$t('general.continue') + ' (' + btnCounter + ')',
              cancelButtonText: self.$t('general.cancel')
            })
            .then((result) => {
              if (result) {
                // remove options
                for (let id of badIds) {
                  for (let k in self.model.product_options) {
                    let o = self.model.product_options[k]
                    let oIdx = self.getObjectByElemKeyValue('id', o.id, self.model.product_options)
                    if (oIdx !== false) {
                      let oLocations = self.model.product_options[oIdx]['location_ids']
                      if (oLocations && oLocations.length !== undefined && oLocations.length && oLocations.indexOf(id) === -1) {
                        self.deleteOptions.push(o.id)
                        Vue.delete(self.model.product_options, k)
                      }
                    }
                  }
                }
                self.prevLocationIds = self.copyObject(self.model.location_ids)
                // return true
              }
            }, function (dismiss) {
              if (dismiss === 'cancel') {
                for (let id of badIds) {
                  let k = self.getObjectByElemKeyValue('id', id, self.model.location_ids)
                  if (k !== false) {
                    Vue.delete(self.model.location_ids, k)
                  }
                }
                self.prevLocationIds = self.copyObject(self.model.location_ids)
              }
            })
            swal.disableConfirmButton()

            var btnInterval = setInterval(function () {
              btnCounter--

              if (btnCounter >= 1) {
                swal.getConfirmButton().textContent = self.$t('general.continue') + ' (' + btnCounter + ')'
              } else {
                swal.getConfirmButton().textContent = self.$t('general.continue')
                clearInterval(btnInterval)
                swal.enableConfirmButton()
              }
            }, 1000)
          }
          self.updateDeliverySettings()
          self.getVatOptions(self.model.locations)
          self.getTaxOption(self.model.locations)
        })
      },
      updateDeliverySettings () {
        this.$nextTick(function () {
          let model = this.model

          if (!Array.isArray(model.override_settings)) {
            Vue.set(this.model, 'override_settings', [])
          }

          let deliveryDetails = []
          let locationSource = this.locations || []

          if (model.location_ids && model.location_ids.length) {
            locationSource = this.locations.filter(loc => {
              return this.getObjectByElemKeyValueBool('id', loc.id, model.location_ids)
            })
          }

          if (!locationSource.length) {
            locationSource = this.locations || []
          }

          for (let loc of locationSource) {
            if (!loc) continue

            let idx = this.getObjectByElemKeyValue('loc_id', loc.id, model.override_settings)
            let existing = (idx !== false && idx !== null && idx !== undefined)
              ? model.override_settings[idx]
              : null

            deliveryDetails.push({
              loc_id: loc.id,
              delivery: this.buildLocationDeliveryMap(loc, existing ? existing.delivery : null)
            })
          }

          Vue.set(this.model, 'override_settings', deliveryDetails)

          this.filterOptionsByLocations()
          this.availableFiltersByLocations()
        })
      },
      showThisLocation (locId) {
        if (
          (Object.keys(this.model.location_ids).length && this.getObjectByElemKeyValueBool('id', locId, this.model.location_ids)) ||
          (!Object.keys(this.model.location_ids).length && this.getObjectByElemKeyValueBool('id', locId, this.locations))
        ) {
          return 1
        } else {
          return 0
        }
      },
      filterOptionsByLocations () {
        if (this.model && this.model.location_ids) {
          let filtered = this.copyObject(this.productOptions)
          let location = this.model.location_ids ? this.model.location_ids : this.locations
          for (let loc of location) {
            for (let prOpt of this.productOptions) {
              let optionLocations = prOpt['location_ids']
              if (optionLocations === undefined || !optionLocations || !optionLocations.length) {
                // all ok
              } else {
                if (!optionLocations.find(obj => obj.token === loc.id)) {
                  let optIdx = this.getObjectByElemKeyValue('id', prOpt.id, filtered)
                  if (optIdx !== false) {
                    Vue.delete(filtered, optIdx)
                  }
                }
              }
            }
          }

          this.productOptionsFiltered = filtered
        }
      },
      availableFiltersByLocations () {
        let filtered = this.copyObject(this.companyProductFilters)
        let location = (this.model && this.model.location_ids && this.model.location_ids.length) ? this.model.location_ids : this.locations
        for (let loc of location) {
          for (let prFilter of this.companyProductFilters) {
            let filterLocations = prFilter['location_ids']
            if (filterLocations === undefined || !filterLocations || (filterLocations && !filterLocations.length)) {
              // all ok
            } else {
              if (filterLocations.indexOf(loc.id) === -1) {
                let filIdx = this.getObjectByElemKeyValue('id', prFilter.id, filtered)
                if (filIdx !== false) {
                  Vue.delete(filtered, filIdx)
                }
              }
            }
          }
        }
        this.productAvailableFilters = filtered
      },
      getProductFilters () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          product_id: this.route.params.id
        }
        this.apiRequest('/filtercatalogproduct', 'GET', data, (response) => {
          if (response.status === true) {
            // this.filtersData = response.data
            const dataWithError = response.data.map(value => ({
              ...value,
              showError: false
            }))
            this.filtersData = dataWithError
            this.$nextTick(() => { this.loading = false })
          }
        })
      },
      getFilData (filterId, what) {
        if (filterId) {
          let prFilIdx = this.getObjectByElemKeyValue('id', filterId, this.companyProductFilters)
          if (prFilIdx) {
            return this.companyProductFilters[prFilIdx][what]
          }
        }
        switch (what) {
          case 'type': return this.$t('filter.filterName')
          default: return null
        }
      },
      changeFilter (thisFilIdx, filId, filter) {
        this.model.product_filters[thisFilIdx]['filter_value'] = []
        this.tabFilterIndex = thisFilIdx
      },
      disableFilter (filIdx, filId, main) {
        let thisFilIdx = false
        if (main) {
          if (this.model.product_filters !== undefined) {
            thisFilIdx = this.getObjectByElemKeyValue('filter_id', filId, this.model.product_filters)
          }
        } else {
          if (this.model.product_filters[filIdx] !== undefined) {
            thisFilIdx = this.getObjectByElemKeyValue('id', filId, this.model.product_filters[filIdx]['filter_value'])
          }
        }

        if (thisFilIdx !== false) {
          return true
        } else {
          return false
        }
      },
      disableFilterValue (filIdx, filId, main) {
        let thisFilIdx = false
        if (main) {
          if (this.model.product_filters !== undefined) {
            thisFilIdx = this.getObjectByElemKeyValue('id', filId, this.model.product_filters)
          }
        } else {
          if (this.model.product_filters[filIdx] !== undefined) {
            thisFilIdx = this.getObjectByElemKeyValue('id', filId, this.model.product_filters[filIdx]['filter_value'])
          }
        }

        if (thisFilIdx !== false) {
          return true
        } else {
          return false
        }
      },
      showAddButtonFilter (filIdx, filter) {
        if (filter === undefined) {
          return false
        }
        if (filter['filter_id'] === undefined) {
          return false
        }
        var existingFilterValues = 0
        existingFilterValues = filter.filter_value.length
        var allFilters = this.companyProductFilters
        if (allFilters === undefined) {
          return false
        }
        let usedFilterKey = this.getObjectByElemKeyValue('id', filter.filter_id, this.companyProductFilters)
        if (usedFilterKey === false) {
          return false
        }
        let count = this.companyProductFilters[usedFilterKey]['filter_value'].length
        return existingFilterValues < count
      },
      addNewFilter () {
        let newRow = {
          'filter_id': 0,
          'type': 0,
          'filter_value': []
        }
        this.model.product_filters.push(newRow)
        this.tabFilterIndex = this.model.product_filters ? this.model.product_filters.length - 1 : 0
      },
      addNeFilterValue (filIdx) {
        let newRow = {
          'id': null,
          'value': 0
        }
        this.model.product_filters[filIdx].filter_value.push(newRow)
      },
      getProductFiltersCount () {
        if (this.model.product_filters) {
          var filterCount = 0
          filterCount = this.model.product_filters.length
          return filterCount
        }
      },
      deleteFilter (thisFilIdx) {
        swal({
          text: this.$t('filter.areYouSureDelete'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            this.model.product_filters.splice(thisFilIdx, 1)
          }
        })
      },
      deleteFilterValue (thisFilIdx, thisValIdx) {
        if (thisValIdx === 0) {
          swal({
            title: '',
            text: this.$t('filter.minOneFilterValueRequired'),
            type: 'error',
            showConfirmButton: false,
            timer: 1500
          }).catch(() => {})
          return false
        }
        this.model.product_filters[thisFilIdx].filter_value.splice(thisValIdx, 1)
      },
      addNewOtherInfo () {
        let newRow = {
          'id': 0,
          'del': 0,
          'title': '',
          'description': ''
        }
        if (!this.model.hasOwnProperty('other_info')) {
          Vue.set(this.model, 'other_info', [])
        }
        this.model.other_info.push(newRow)
        this.tabOtherInfoIndex = this.model.other_info ? this.model.other_info.length - 1 : 0
      },
      deleteOtherInfo (id) {
        swal({
          text: this.$t('filter.areYouSureDelete'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            Vue.set(this.model.other_info[id], 'del', 1)
          }
        })
      },
      doReloadProd (obj) {
        this.getData()
      },
      handleDateChange (event) {
        const date = new Date()
        let today = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString().split('T')[0]
        if (!event) {
          this.model.price = this.model.new_price ? this.model.new_price : this.model.price
          this.model.valid_from = this.model.valid_to = this.model.discountPeriod = null
        } else if (event && today >= event[0] && today <= event[1] && this.model.new_price <= this.model.price) {
          this.model.price = this.model.new_price ? this.model.new_price : this.model.price
          this.model.valid_from = event[0]
          this.model.valid_to = event[1]
        } else {
          this.model.price = this.model.old_price ? this.model.old_price : this.model.price
          this.model.valid_from = event[0]
          this.model.valid_to = event[1]
        }
      },
      handleDiscountedPrice (event) {
        if (this.model.is_discounted) {
          this.model.old_price = this.model.price
          this.model.valid_from = null
          this.model.valid_to = null
          this.model.discountPeriod = []
        } else {
          this.model.price = (this.model.old_price && this.model.old_price > this.model.price) ? this.model.old_price : this.model.price
          this.model.new_price = null
          this.model.old_price = null
          this.model.valid_from = null
          this.model.valid_to = null
          this.model.discountPeriod = []
        }
      },
      handleNewPriceChange () {
        const date = new Date()
        let today = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString().split('T')[0]
        if (this.model.new_price <= this.model.old_price) {
          if (!this.model.valid_from || today >= this.model.valid_from && today <= this.model.valid_to) {
            this.model.price = this.model.new_price ? this.model.new_price : this.model.price
          } else {
            this.model.price = this.model.old_price ? this.model.old_price : this.model.price
          }
        }
      },
      handlePriceChange () {
        const date = new Date()
        let today = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1).toISOString().split('T')[0]
        if (today < this.model.valid_from) {
          this.model.old_price = this.model.price
        }
      },
      goToLink (link, newTab) {
        window.open(link, newTab)
      },
      handleProductUnavailable (newValue) {
        if (newValue === true && this.model.active !== true) {
          swal({
            type: 'warning',
            title: this.$t('catalogProd.swalTitleChangeStatus'),
            width: 600
            // timer: 4000
          })
          this.model.is_not_available = false
        }
      },
      openSection (section) {
        this.currentSection = section
      },
      openSubSection (section) {
        this.currentSubSection = section
      },
      initCharismaAdministrations () {
        const sessionData = this.$session.get('selectedCompanyData') || {}
        const locationsDetails = sessionData.locations_details || []

        if (!sessionData.locations_list) {
          const locationsList = locationsDetails.map(location => ({
            id: location.true_id,
            name: location.name
          }))
          sessionData.locations_list = locationsList
          this.$session.set('selectedCompanyData', sessionData)
        }
        this.charismaLocations = sessionData.locations_list

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        if (!sessionData.administrations) {
          this.apiRequest('/administration', 'GET', data, (response) => {
            if (response.status) {
              sessionData.administrations = response.data
              this.administrations = response.data
              this.$session.set('selectedCompanyData', sessionData)
            }
          })
        } else {
          this.administrations = sessionData.administrations
        }
      },
      addAdministrationRow () {
        if (!this.model.administrations) {
          Vue.set(this.model, 'administrations', [])
        }

        this.model.administrations.push({
          id: null,
          company_id: this.$session.get('selectedCompany'),
          administration_id: null,
          location_ids: []
        })
      },
      removeAdministrationRow (index) {
        const removed = this.model.administrations[index]

        if (removed.id) {
          this.administrationsToDelete.push(removed.id)
        }

        this.model.administrations.splice(index, 1)
      },
      availableAdministrations (currentId) {
        const used = this.model.administrations.map(r => r.administration_id).filter(id => id !== currentId)
        return this.administrations.filter(a => !used.includes(a.id))
      },
      mapLocationIdsToObjects () {
        const administrations = this.model.administrations || []

        administrations.forEach(admin => {
          if (Array.isArray(admin.location_ids)) {
            admin.location_ids = admin.location_ids
              .map(loc => (typeof loc === 'object' && loc ? loc.id : loc))
              .filter(id => id != null)
          }
        })
        this.model.administrations = administrations
      }
    }
  }
</script>
<style>
  .sold-with-tree .halo-tree .inputCheck.box-halfchecked:after {
    content: "\2212";
    color: #555;
    top: 3px;
  }
  .product-option-value-select {
    width: 100%;
  }
  .charisma-location-select {
    width: 100%;
  }
  .charisma-location-select .el-select__tags {
    max-width: 100%;
  }
  .change {
    background-color: #674BD2;
    border-color: #674BD2;
    color: #fff;
  }
  .centerSearch {
    width: 100%;
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vat-boxes {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
  .vat-box {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    width: 100%;
    background: #fafafa;
  }
  .vat-header {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .linked-product-name {
    font-weight: 600;
  }
  .linked-product-id {
    font-size: 14px;
    margin-bottom: 5px;
  }
  .search-item {
    padding: 8px;
    cursor: pointer;
    border-bottom: 1px solid #ccc;
    padding: 10px 20px;
    &.active {
      background: #e5e3e3;
    }
  }
  .search-item:hover {
    background: #d3cece;
  }
  .search-results {
    position: relative;
    height: 350px;
    overflow: auto;
    background: #fff;
  }
  .searchId {
    font-size: 10px;
    margin-bottom: 5px;
  }
  .btnSearch {
    min-width: 120px;
    font-size: 14px;
    padding: 10px 15px;
    width: auto;
    height: auto;
  }
  .searchBadge {
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 10px;
    color: #fff;
  }
  .reteta {
    background: red;
    color: #fff;
    padding: 5px 10px;
    display: inline-block;
    border-radius: 20px;
    font-size: 10px;
  }

  .prevewLabel {
    background: #fff;
    padding: 20px;
    max-width: 330px;
    max-height: 170px;
  }
  .prevewLabel .prevewLabel_title {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .prevewLabel .prevewLabel_txt {
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 5px;
  }

  textarea.form-control {
    resize: vertical !important;
    min-height: 200px;
  }
  .upload-demo input[type="file"]{ display: none; }
  .alert-custom-danger { color: #FF0D19 !important; border-radius: 4px; }
  div.el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange {
    width: auto;
  }
  .product-availability {
    margin-bottom: 10px !important;
  }
  .product-availability .el-collapse-item__content {
    padding-bottom: 0;
  }
  .product-override-group {
    margin-bottom: 24px;
    clear: both;
  }
  .product-override-collapse {
    display: block;
    clear: both;
    margin: 12px 0 8px;
    border-top: 1px solid #ebeef5;
    width: 100%;
  }
  .product-override-collapse .el-collapse-item__header {
    height: auto;
    min-height: 48px;
    line-height: 1.4;
    padding: 12px 0;
  }
  .product-override-collapse .el-collapse-item {
    margin-bottom: 4px;
  }
  .errorT {
    color: red !important;
  }
  .order-label-hint {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/ProductForm.vue